var App = App || {};

(function () {
	let self = App.editor = {

		obj: null,
		body: null,
		toolbar: null,
		menu_more: null,
		init_once: false,
		next_num: 0,

		allow_form_events: false,

		symbol_tracked: '',
		input_tracked: 0,
		input_sequential_text: false,

		colors_light: ['#fdf45f', '#c4ffa6', '#b7dde8', '#fbd5b5', '#f7cde6', '#cfcdf7', '#e5e5e5'],
		colors_dark: ['#ccc220', '#9dcc85', '#62b8d1', '#eb9595', '#f7cde6', '#d8a4d8', '#5a6a77'],
		color_regexp_light: null,
		color_regexp_dark: null,

		submit_hotkey_check: null,

		color_analog: {
			'#fdf45f': '#ccc220',
			'#c4ffa6': '#9dcc85',
			'#b7dde8': '#62b8d1',
			'#fbd5b5': '#eb9595',
			'#f7cde6': '#f7cde6',
			'#cfcdf7': '#d8a4d8',
			'#e5e5e5': '#5a6a77',
		},
		rgb_analog: {
			'253, 244, 95': '204, 194, 32',
			'196, 255, 166': '157, 204, 133',
			'183, 221, 232': '98, 184, 209',
			'251, 213, 181': '235, 149, 149',
			'247, 205, 230': '247, 205, 230',
			'207, 205, 247': '216, 164, 216',
			'229, 229, 229': '90, 106, 119',
		},

		clear_all: false,
		need_clean: false,

		_skip_next_blur: false,

		set_skip_next_blur: function (value) {
			self._skip_next_blur = value;
		},

		init_colors: function () {
			if (self.color_regexp_light == null) {
				let arr_tmp = [];
				for (let i in self.color_analog) arr_tmp[arr_tmp.length] = i;
				for (let i in self.rgb_analog) arr_tmp[arr_tmp.length] = 'rgba?\\(' + i;
				self.color_regexp_light = new RegExp('(' + arr_tmp.join('|') + ')');
				arr_tmp = [];
				for (let i in self.color_analog) arr_tmp[arr_tmp.length] = self.color_analog[i];
				for (let i in self.rgb_analog) arr_tmp[arr_tmp.length] = 'rgba?\\(' + self.rgb_analog[i];
				self.color_regexp_dark = new RegExp('(' + arr_tmp.join('|') + ')');
			}
		},

		is_active: function () {
			return document.activeElement.className && document.activeElement.className.indexOf('editor__data') >= 0;
		},

		is_focused: function () {
			return App.editor.body != null && App.editor.body.is(':focus');
		},

		num: function () {
			return 1 * self.body.attr('data-editor');
		},

		init: function (obj, options) {
			options ||= {};
			self.init_colors();
			self.obj = $(obj);
			self.body = self.obj.find('.editor__data');
			self.toolbar = self.obj.find('.editor__toolbar');

			// self.body.addClass('ignore_hide'); // тест для emoji.inline_menu

			if (!self.obj.length || !self.body.length) return;
			self.restore_toolbar_state();
			if (self.body.attr('data-editor-init')) return;
			self.allow_form_events = false;
			self.set_skip_next_blur(false);
			self.body.attr('data-editor', self.next_num++).attr('data-editor-init', 1);
			self.body.bind('focus', function (e) {
				self.set_skip_next_blur(false);
				self.toolbar.addClass('editor__toolbar-active');
				self.onselectionchange(e);
			}).bind('blur', function (e) {
				if (self.menu_show_timer) clearTimeout(self.menu_show_timer);
				if (self.toolbar.find('.editor-btn.menu_open').length > 0) return;
				if (self._skip_next_blur) {
					self.set_skip_next_blur(false);
					return;
				}
				self.toolbar.removeClass('editor__toolbar-active');
				// кейс - на мобілі треба щоб розфокус через системну кнопку Готово (ios), згортав форму в мінімальний вид
				// пробую, але не все так просто, бо є менюшки, наприклад емоджі, які при закритті не мають "згортати" форму
				// тому додав перевірку timestamp останнього тичка в елемент на сторінці
				if (
					App.device.is_mobile()
					&& App.comment_form.is_shown()
					&& !App.comment_form.is_expanded()
					&& new Date().getTime() - App.comment_form.last_touch_timestamp > 250 // якщо не хватить, можна зменшити до ~50ms
				) {
					App.comment_form.stop();
				}
			}).bind('click', function (e) {
				self.onclick(e);
			}).bind('keyup click', function () {
				self.update();
			}).bind('paste', function (e) {
				self.onpaste(e);
			}).bind('cut', function (e) {
				self.oncut(e);
			}).bind('keyup keypress', function (e) {
				self.onkeyup(e);
			}).on('beforeinput', function (e) {
				if (self.beforeinput_delete(e)) {
					e.preventDefault();
				}
			}).on('input', function (e) {
				self.oninput_delete(e);
			}).bind(App.device.is_mobile() ? 'textInput' : 'keydown', function (e) {

				if (options.onkeydown && options.onkeydown(e)) {
					e.preventDefault();
					e.stopPropagation();
					return false;
				}

				self.onkeydown(e);
			}).bind('mousedown mouseup keydown keyup', function () {
				self.save_range();
			});

			self.init_from_html(self.obj.find('.editor__textarea').val(), 'first');
			self.css_style(true);

			self.obj.find('.editor__toolbar').once_by_criteria('editor_button_click').bind('mousedown', function (e) {
				self.set_skip_next_blur(true);
				e.preventDefault();
				return false;
			});
			self.obj.find('.editor__toolbar a').not('[onclick]').once_by_criteria('editor_button_click').bind('mousedown', function (e) {
				self.set_skip_next_blur(true);
				e.preventDefault();
				return self.button($(this).attr('data-btn'));
			});

			if (self.body.attr('data-draft')) {
				toolbar = self.toolbar;
				$('#draft_save').hide().appendTo(toolbar);
				//$('#subscribe_me').show().appendTo(toolbar);
				if (!App.device.is_mobile()) $('a#draft_del').hide(); //prependTo(toolbar);
				$('<span class="loader_sm loader_err" id="draft_error"></span>').prependTo(toolbar);
				//$('<span class="loader_sm" id="draft_load"></span>').prependTo(toolbar);
			}
			self.init_once = true;
			self.allow_form_events = true;
		},

		init_from_html: function (html, type) {
			App.classes.ui_state_manager.getInstance().loadState({
				onLoaded(state) {
					if (App.device.is_lg_width()) {
						self.body.parent().toggleClass('with-topToolbar', Boolean(self.obj.find('.editor-btn[data-btn=toolbar]').length === 0 || state.editor_toolbar));
					}
				}
			});

			if (!type) type = '';
			if (type === 'first') {
				let arr_tmp = [];
				for (let i in self.color_analog) {
					arr_tmp[arr_tmp.length] = i;
					arr_tmp[arr_tmp.length] = self.color_analog[i];
				}
				for (let i in self.rgb_analog) {
					arr_tmp[arr_tmp.length] = 'rgba?\\(' + i;
					arr_tmp[arr_tmp.length] = 'rgba?\\(' + self.rgb_analog[i];
				}
				if ($('body').attr('data-color')) {
					html = html.replace(new RegExp('(background-color|background|color):\\s*(' + arr_tmp.join('|') + ')', 'g'), function (match, p1, p2, offset, string) {
						for (let i in self.color_analog) p2 = p2.replace(i, self.color_analog[i]);
						for (let i in self.rgb_analog) p2 = p2.replace(i, self.rgb_analog[i]);
						return 'color: ' + p2;
					});
				}
			}

			self.body.html(html);

			if (type === 'first') {
				self.body.find('address, pre, scode').attr('spellcheck', false);
				self.body.find('span.invite').each(function () {
					if (!this.previousSibling || this.previousSibling.nodeType !== 3 || !this.previousSibling.textContent) $(this).before(document.createTextNode("\u200b"));
					if (!this.nextSibling || this.nextSibling.nodeType !== 3 || !this.nextSibling.textContent) $(this).after(document.createTextNode("\u00a0"));
				});
				self.body.find('a.inline_task, span.contact').attr('spellcheck', false).attr('contenteditable', false);
				self.body.find('table').attr('spellcheck', false).attr('contenteditable', false).each(function () {
					if (self.dom_helper.is_last(this)) $(this).after('<br>');
					if (self.dom_helper.is_first(this)) $(this).before(document.createTextNode("\u200b"));
				})
				self.body.find('a').not('.inline_task').each(function () {
					$(this).toggleClass('inline_file', self.is_inline_file($(this).attr('href')));
				});
				self.body.find('li:empty').append('<br/>');
				if (self.body.html() === '&nbsp;') self.body.html('');
				self.mention.clean();
				self.mention.sync();
			}
			self.need_clean = self.body.find('*').not('div, p, br').length > 0;
			self.save();
			self.update();
			if (type === 'first') App.draft.save_state();
			if (type !== 'snapshot') self.undo_init();
			if (!App.device.is_mobile() && (type !== 'first' || self.body.attr('data-focus'))) {
				tmp_scr = $(window).scrollTop();
				self.focus();
				$(window).scrollTop(tmp_scr);
			}
		},

		focus: function (keep_pos) {
			self.body.focus();
			if (!keep_pos) self.cursor_toend();
		},

		is_empty_body: function () {
			return self.body != null && self.body.text().trim() === '' && self.body.find('br').length < 2 && self.body.children('ol,ul,address,pre,hr').length === 0;
		},

		save: function () {
			let editor = self.body.closest('.editor');

			self.body.children('p').each(function () {
				if ($(this).text().trim() === '') $(this).remove();
			})

			let save_html = self.body.html();
			save_html = self.mention.save(save_html);
			editor.find('.editor__textarea').val(save_html);

			if (self.is_empty_body()) {
				editor.find('.placeholder').show();
				editor.find('.editor__textarea').val('');
				self.body.html('');
				self.need_clean = false;
			} else {
				editor.find('.placeholder').hide();
			}

			if (self.allow_form_events) {
				self.body.parents('form').trigger('change');
			}
		},

		save_draft: function () {
			App.menu.hide();
			App.draft.save(true);
			return false;
		},

		button: function (btn) {
			let docont, o_bar, o_but;
			//if (!self.is_active()) debugger;
			self.save_range();
			//if (!self.is_active()) debugger;
			if (!self.is_active()) {
				if ((App.device.is_mobile()) && [
					'delete', 'redo', 'undo',
					'attach', // якогось чорта все одно відкриває клавіатуру.. треба ще копати
					'more',
					'mention',
				].includes(btn)) {
				} else {
					self.body.focus();
					self.restore_range();
				}
			}

			switch (btn) {
				case 'bold':
				case 'italic':
				case 'underline':
				case 'strikethrough':
					self.need_clean = true;
					self.css_style(false);
					document.execCommand(btn);
					self.css_style(true);
					break;

				case 'section_break':
					const exit_node = $(self.getParentElement()).closest('ul, ol, scode');

					if (exit_node.length === 1) {
						self.cursor_after(exit_node.get(0));
					}

					self.insert(document.createElement('hr'), true)
					break;

				case 'new_line':
					range = self.range();
					range.insertNode(br = document.createElement("br"));
					range.endContainer.normalize();
					self.cursor_after(br);
					break;

				case 'inline_code':
					link = self.getParentElement();
					let sel_text = self.selection().toString().trim();

					if (sel_text.split('\n').length > 1) return false;

					let link_scode = $(link).parents().addBack().filter('scode').filter(':first');
					let link_tag = $(link).parents().addBack().filter('pre,a').filter(':first');

					if (link_scode.length > 0) {
						$(link_scode).replaceWith(document.createTextNode(link_scode.text().trim()));
					} else if (link_tag.length > 0) {
						$(link_tag).replaceWith($('<scode>').text(link_tag.text().trim()).get(0));
					} else if (sel_text.length > 0) {
						range = self.range();
						if (!range.collapsed) range.deleteContents();
						self.insert($('<scode>').text(sel_text).get(0), true)
					}

					self.body.find('scode').attr('spellcheck', false);

					break;
				case 'code':
					self.need_clean = true;
					update = 0;
					remove = /^(pre|пре)/.test((self.button_value('formatblock')).toLowerCase()) ? 1 : 0;
					if (self.range().collapsed) {
						link = self.getParentElement();
						link = $(link).parents().addBack().filter('pre').filter(':first');
						if (link.length) remove = 2; else {
							link = self.getParentElement();
							link = $(link).parents().addBack().filter('blockquote,address,scode').filter(':first');
							if (link.length) update = 1;
						}
					}
					if (remove == 2) {
						let html = $(link).html();
						let text = html.replace(/<br\s*\/?>/gi, '<br>\n');
						const tmp = document.createElement('div');
						tmp.innerHTML = text;
						let cleaned = '';
						Array.from(tmp.childNodes).forEach(node => {
							if (node.nodeType === Node.TEXT_NODE) {
								cleaned += node.textContent;
							} else if (node.nodeType === Node.ELEMENT_NODE) {
								cleaned += $(node).text();
							}
						});
						const container = document.createElement('div');
						container.style.whiteSpace = 'pre-wrap';
						container.appendChild(document.createTextNode(cleaned));
						$(link).replaceWith(container);
					} else if (remove) {
						self.formatblock('div');
					} else {
						self.body.find('pre').addClass('wadd_tmp');
						if (update) {
							$(link).replaceWith('<pre>' + $(link).html() + '</pre>');
						} else {
							self.formatblock('pre');
						}
						self.body.find('pre pre').each(function () {
							$(this).replaceWith($(this).html());
						});
						// Webkit list-item -> code
						self.body.find('pre ul, pre ol, pre scode').each(function () {
							$(this).replaceWith($(this).html());
						});
						self.body.find('pre li').each(function () {
							$(this).replaceWith('<br>' + $(this).html().replace(/<br[^>]*>$/i, ''));
						});
						// FireFox list-item -> code
						self.body.find('ul pre, ol pre').each(function () {
							$(this).parents('ul, ol').addClass('wdel').after(this);
						});
						self.body.find('ul.wdel, ol.wdel').remove();

						self.body.find('pre').not('.wadd_tmp').addClass('wadd_tmp2').attr('spellcheck', false);
						self.body.find('pre.wadd_tmp2').prev().filter('pre').addClass('wadd_tmp2');
						self.body.find('pre.wadd_tmp2').each(function () {
							if ($(this).parent().not('.editor__data').is('div') && !$(this).next().length && !$(this).prev().length) $(this).insertAfter($(this).parent()).prev().remove();
							$(this).find('a, b, i, span').each(function () {
								$(this).replaceWith($(this).html());
							});
							if (this.childNodes.length > 1 && this.childNodes[this.childNodes.length - 1].nodeName.toLowerCase() == 'br') $(this.childNodes[this.childNodes.length - 1]).remove();
							if (this.childNodes.length > 1 && this.childNodes[0].nodeName.toLowerCase() == 'br') $(this.childNodes[0]).remove();
						});
						wadd_tmp = self.body.find('pre.wadd_tmp2:first');
						while (wadd_tmp.next().hasClass('wadd_tmp2')) {
							wadd_tmp.append('<br>' + wadd_tmp.next().html());
							wadd_tmp.next().remove();
						}
						self.body.find('pre').removeAttr('class').filter(':last').each(function () {
							if (!$(this).next().length) $(this).after('<br>');
						});
						if (wadd_tmp) {
							if (!wadd_tmp.html()) {
								self.cursor_before($('<br>').appendTo(wadd_tmp).get(0));
							} else self.cursor_toend(wadd_tmp.get(0));
						}
					}
					break;

				case 'quote':
					self.need_clean = true;
					update = 0;
					remove = /^(add?r|адр)/.test((self.button_value('formatblock')).toLowerCase()) ? 1 : 0;
					if (self.range().collapsed) {
						link = self.getParentElement();
						link = $(link).parents().addBack().filter('blockquote,address').filter(':first');
						if (link.length) remove = 2; else {
							link = self.getParentElement();
							link = $(link).parents().addBack().filter('pre').filter(':first');
							if (link.length) update = 1;
						}
					}
					if (remove == 2) {
						$(link).replaceWith($.browser.mozilla ? $(link).html() : '<div>' + $(link).html().replace(/\n/g, '<br>').replace(/\t/g, "\u2003\u2003").replace(/  /g, "\u00a0 ") + '</div>');
					} else if (remove) {
						self.formatblock('div');
					} else {
						self.body.find('address').addClass('wadd_tmp');
						if (update) {
							$(link).replaceWith('<address>' + $(link).html().replace(/\n/g, '<br>').replace(/\t/g, "\u2003\u2003").replace(/  /g, "\u00a0 ") + '</address>');
						} else {
							self.formatblock('blockquote');
							self.body.find('blockquote').each(function () {
								$(this).replaceWith('<address>' + $(this).html() + '</address>');
							}); // $(this).contents().wrap('<address></address>').parent()
							self.body.find('address address').each(function () {
								$(this).replaceWith($(this).html());
							});
							self.body.find('address pre').each(function () {
								$(this).replaceWith($(this).html().replace(/\n/g, '<br>').replace(/\t/g, "\u2003\u2003").replace(/  /g, "\u00a0 "));
							});

							self.body.find('address div, address p').each(function () {
								$(this).replaceWith('<br>' + $(this).html().replace(/<br[^>]*>$/i, ''));
							});
							self.body.find('address ul, address ol').each(function () {
								$(this).replaceWith($(this).html());
							});
							self.body.find('address li').each(function () {
								$(this).replaceWith('<br>' + $(this).html().replace(/<br[^>]*>$/i, ''));
							});
							self.body.find('address').each(function () {
								if (this.childNodes.length > 1 && this.childNodes[this.childNodes.length - 1].nodeName.toLowerCase() == 'br') $(this.childNodes[this.childNodes.length - 1]).remove();
								if (this.childNodes.length > 1 && this.childNodes[0].nodeName.toLowerCase() == 'br') $(this.childNodes[0]).remove();
							});
						}
						self.body.find('address').not('.wadd_tmp').addClass('wadd_tmp2').attr('spellcheck', false);
						self.body.find('address.wadd_tmp2').prev().filter('address').addClass('wadd_tmp2');
						wadd_tmp = self.body.find('address.wadd_tmp2:first');
						while (wadd_tmp.next().hasClass('wadd_tmp2')) {
							html = wadd_tmp.next().html().replace(/<br[^>]*>$/i, '');
							if (html.trim()) wadd_tmp.append('<br>' + html);
							wadd_tmp.next().remove();
						}
						self.body.find('address').removeAttr('class').filter(':last').each(function () {
							if (!$(this).next().length) $(this).after('<br>');
						});
						if (wadd_tmp) {
							if (!wadd_tmp.html()) {
								self.cursor_before($('<br>').appendTo(wadd_tmp).get(0));
							} else self.cursor_toend(wadd_tmp.get(0));
						}
					}
					break;

				case 'list_bullet':
					o = $(self.getParentElement()).parents().addBack();
					docont = true;
					if (self.button_state('insertorderedlist') || o.filter('ol').length) {
						o = o.filter('ol:first');
						o.after('<ul/>');
						o.find('li').appendTo(o.next());
						self.cursor_toend(o.next().find('li:last').get(0));
						o.remove();
						docont = false;
					}
					if (docont) {
						if (!self.button_state('insertunorderedlist') && (o.filter('ul').length > 0)) self.cursor_wrap(o.filter('li').get(0))
						document.execCommand('insertunorderedlist');
					}
					// Webkit list-item -> code
					self.body.find('pre ul, address ul, blockquote ul').each(function () {
						$(this).parents('pre, address, blockquote').addClass('wdel').after(this);
					});
					self.body.find('pre.wdel, address.wdel, blockquote.wdel').remove();
					// FireFox list-item -> code
					self.body.find('ul pre, ul address, ul blockquote').each(function () {
						$(this).replaceWith($(this).html());
					});
					break;

				case 'list_num':
				case 'list_todo':
					if (btn === 'list_todo') self.need_clean = true;
					o = $(self.getParentElement()).parents().addBack();
					docont = true;
					if (self.button_state('insertunorderedlist') || o.filter('ul').length) {
						o = o.filter('ul:first');
						o.after('<ol/>');
						o.find('li').appendTo(o.next());
						if (btn === 'list_todo') o.next().addClass('todo');
						self.cursor_toend(o.next().find('li:last').get(0));
						o.remove();
						docont = false;
					}
					if (docont && self.button_state('insertorderedlist') || o.filter('ol').length) {
						o = o.filter('ol:first');
						if (btn === 'list_todo' && !o.hasClass('todo')) {
							o.attr('class', 'todo');
							docont = false;
						} else if (btn != 'list_todo' && o.hasClass('todo')) {
							o.removeAttr('class');
							docont = false;
						}
					}
					if (docont) {
						$(document.body).find('ol').addClass('todocheck');
						if (!self.button_state('insertorderedlist') && (o.filter('ol').length > 0)) self.cursor_wrap(o.filter('li').get(0))
						document.execCommand('insertorderedlist');
						link = self.getParentElement();
						while (link && !/^(ol|ul)$/i.test(link.tagName)) link = link.parentNode;
						if (link) {
							link.className = (btn === 'list_todo') ? 'todo' : '';
						} else {
							if (btn === 'list_todo') $(document.body).find('ol').not('.todocheck').addClass('todo'); else $(document.body).find('ol').not('.todocheck').removeClass('todo');
						}
						$(document.body).find('ol').removeClass('todocheck').not('.todo').removeAttr('class');
					}
					// Webkit list-item -> code
					self.body.find('pre ol, address ol, blockquote ol').each(function () {
						$(this).parents('pre, address, blockquote').addClass('wdel').after(this);
					});
					self.body.find('pre.wdel, address.wdel, blockquote.wdel').remove();
					// FireFox list-item -> code
					self.body.find('ol pre, ol address, ol blockquote').each(function () {
						$(this).replaceWith($(this).html());
					});
					break;

				case 'mention':
					$(document).bind('menu_unload.once', () => self.restore_range());
					self.input_sequential_text = '';
					self.helper_mention({
						type: 'left',
					});
					App.menu.in_editor = true;
					return false;

				case 'task':
					$(document).bind('menu_unload.once', () => self.restore_range());
					self.input_sequential_text = '';
					self.helper_task_select({
						type: 'left',
					});
					App.menu.in_editor = true;
					return false;

				case 'color_bg':
					let bc = '', is_colored = false, add_text = false,
						command = $.browser.msie || $.browser.webkit ? "backcolor" : "hilitecolor";
					if ($('body').attr('data-color')) command = 'foreColor';

					if (!self.selection().toString().length) {
						bc = self._makeColor(self.button_value(command));
					} else if ($(self.getParentElement()).is('span')) {
						bc = $(self.getParentElement()).css('backgroundColor');
					}

					if (bc !== '') {
						is_colored = ($('body').attr('data-color') ? self.color_regexp_dark : self.color_regexp_light).test(bc);
						add_text = !is_colored && self.selection().toString().length === 0;
						if (!is_colored) bc = '';
					}

					App.menu.hide();
					$(document).bind('menu_unload.once', () => self.restore_range());
					self.helper_highlight({
						type: add_text ? 'left' : 'center',
						value: {color: bc, is_new: !is_colored, add_text: add_text},
					})
					App.menu.in_editor = true;
					return false;

				case 'link':
					let link_el = $(self.getParentElement()).parents().addBack().filter('a');

					let href = link_el.attr('href') || '', label = link_el.text() || '', is_new = false;
					if (!href) {
						label = href = self.selection().toString().trim();
						if (App.helper.is_link(href)) {
							href = href.indexOf('://') === -1 ? 'https://' + href : href;
						} else {
							href = '';
						}
					}

					is_new = link_el.attr('href') == null;

					const open = (url) => {
						href = href || url || '';
						label = label || href.split('://').pop();

						App.menu.hide();
						self.helper_link({
							type: 'center',
							value: {href, label, is_new},
						})
						App.menu.in_editor = true;
					}

					if (is_new) {
						App.helper.clipboard.get_link(open)
					} else {
						open();
					}

					return false;

				case 'clean':
					sel = self.selection();
					range = self.range(sel);
					collapse = range.collapsed;
					sel_status = false;
					node1 = range.startContainer;
					node2 = range.endContainer;
					node1_include = false;
					node2_include = true;
					if (self.clear_all) {
						self.clear_all = null;
						selection = self.body.find('*');
					} else if (collapse) {
						if (node1.nodeType === Node.TEXT_NODE) node1 = node1.parentNode;
						while (node1 != null && !$(node1).is('span[style], b, i, strike, s, u, a, address, blockquote, scode, pre, li, ws-emoij, .editor__data')) node1 = node1.parentNode;
						if ($(node1).hasClass('editor__data')) {
							let title = App.object_state.locale.editor.names.clean;
							let btn_text = App.object_state.locale.editor.names.clean_confirm || 'Clean';
							let el = self.obj.find('.editor__toolbar .more:visible').get(0);

							App.menu.hide();
							App.controls.confirm.menu(el, {
								message: title,
								ok_label: btn_text,
								onconfirm: function () {
									App.editor.clear_all = true;
									App.editor.button('clean');
								}
							});
							return false;
						} else {
							App.menu.hide();
						}
						selection = $(node1);
					} else {
						App.menu.hide();
						if (node1.nodeType !== 3) {
							if (range.startOffset === 0) {
								node1_include = true;
							} else {
								node1 = node1.childNodes[range.startOffset - 1];
							}
						} else if (range.startOffset === 0 && self.dom_helper.is_first(node1)) {
							node1 = node1.parentNode;
							while (self.dom_helper.is_first(node1)) node1 = node1.parentNode;
							node1_include = true;
						} else {
							while (node1.nodeType === Node.TEXT_NODE && node1.previousSibling) node1 = node1.previousSibling;
							// if (!node1.previousSibling) node1 = node1.parentNode;
							if (node1.nodeType === Node.TEXT_NODE) node1 = node1.parentNode; else node1_include = false;
						}
						if (node2.nodeType !== 3) {
							node2 = node2.childNodes[range.endOffset - 1];
						} else if (range.endOffset === 0) {
							while (node2.nodeType === Node.TEXT_NODE) node2 = node2.parentNode;
							while (self.dom_helper.is_first(node1)) node2 = node2.parentNode;
							node2_include = false;
						} else {
							while (node2.nodeType === Node.TEXT_NODE && node2.nextSibling) node2 = node2.nextSibling;
							node2_include = false;
							if (node2.nextSibling) {
							} else {
								// Changed to recurtion
								//  if (node2.parentNode) {
								//   node2 = node2.parentNode;
								//   while (node2.nextSibling && node2.nextSibling.nodeType === Node.TEXT_NODE) node2 = node2.nextSibling;
								//   if (node2.nextSibling) node2 = node2.nextSibling; else if (node2.parentNode) {
								//     node2 = node2.parentNode;
								//     while (node2.nextSibling && node2.nextSibling.nodeType === Node.TEXT_NODE) node2 = node2.nextSibling;
								//     if (node2.nextSibling) node2 = node2.nextSibling; else node2 = null;
								//   }
								// }
								let do_dig = true;
								while (do_dig) {
									if (node2.parentNode) {
										node2 = node2.parentNode;
										while (node2.nextSibling && node2.nextSibling.nodeType === Node.TEXT_NODE) node2 = node2.nextSibling;
										if (node2.nextSibling) {
											do_dig = false;
											node2 = node2.nextSibling;
										}
									}
								}
							}
						}
						if (node1 == self.body.get(0)) sel_status = true;
						if (node1.nodeName.toLowerCase() == 'table' && !node1_include) { // HotFix: start clean after table
							node1 = $(node1).find('*').get(-1);
						}
						selection = self.body.find('*');
						selection = selection.filter(function () {
							if (this == node1) {
								sel_status = true;
								if (!node1_include) return false;
							}
							if (this == node2) {
								sel_status = false;
								if (node2_include) return true;
							}
							return sel_status;
						});
					}
					selection.filter('span, font, b, i, strike, s, u, a, scode').each(function () {
						if ($(this).hasClass('contact')) return;
						if ($(this).hasClass('inline_task')) return;
						if ($(this).hasClass('invite')) return;

						$(this).contents().insertBefore($(this));
						$(this).remove();
					});
					selection.filter('address, blockquote, pre').each(function () {
						$(this).replaceWith($(this).html().replace(/<br[^>]*>$/i, '') + '<br>');
					});
					selection.filter('li').addClass('wdel').parent('ul, ol').addClass('wtmp');

					self.body.find('ul.wtmp, ol.wtmp').each(function () {
						fl_tmp = true;
						o = $(this).children().filter(function () {
							if ($(this).hasClass('wdel')) fl_tmp = false;
							return fl_tmp;
						});
						if (o.length) {
							$('<' + this.tagName.toLowerCase() + ($(this).hasClass('todo') ? ' class="todo"' : '') + '></' + this.tagName.toLowerCase() + '>').insertBefore(this).append(o);
						}
						fl_tmp = false;
						o = $(this).children().filter(function () {
							if (!$(this).hasClass('wdel')) fl_tmp = true;
							return fl_tmp;
						});
						if (o.length) {
							$('<' + this.tagName.toLowerCase() + ($(this).hasClass('todo') ? ' class="todo"' : '') + '></' + this.tagName.toLowerCase() + '>').insertAfter(this).append(o);
						}
						$(this).find('li').each(function () {
							$(this).replaceWith('<br>' + $(this).html().replace(/<br[^>]*>$/i, ''));
						});
						if (this.childNodes.length > 1 && this.childNodes[0].nodeName.toLowerCase() == 'br') $(this.childNodes[0]).remove();
						$(this).replaceWith($(this).html().replace(/<br[^>]*>$/i, '') + '<br>');
					});

					selection.each(function () {
						if ($(this).is('ws-emoji')) return;
						if ($(this).hasClass('contact')) return;
						if ($(this).hasClass('inline_task')) return;
						if ($(this).hasClass('invite')) return;

						if (this.attributes.length) {
							let rm_attr = [];
							$.each(this.attributes, function () {
								if (!/(contenteditable|spellcheck|href|rel|data-txt|colspan|rowspan)/.test(this.name)) rm_attr.push(this.name);
							});
							for (i in rm_attr) $(this).removeAttr(rm_attr[i]);
						}
					});
					self.need_clean = self.body.find('*').not('div, p, br').length > 0;
					break;
				case 'undo':
					self.undo();
					break;
				case 'redo':
					self.redo();
					break;
				case 'delete':
					let el = self.obj.find('.editor__toolbar .more:visible').get(0);
					App.menu.hide();
					App.controls.confirm.menu(el, {
						message: $('#draft_del').attr('data-title'),
						ok_label: App.object_state.locale.yes_delete,
						onconfirm: function () {
							App.draft.delete($('#draft_del').get(0));
						}
					});
					return false;

				case 'toolbar':

					if (App.device.is_mobile() && !self.is_toolbar_shown()) {
						App.comment_form.expand(); // toolbar will be shown on expand
						return;
					}

					self.body.parent().toggleClass('with-topToolbar');
					// self.onresize()
					if (App.device.is_lg_width()) App.classes.ui_state_manager.getInstance().setState('editor_toolbar', self.is_toolbar_shown());
					self.update();
					App.comment_form.reinit_scroll_zones();
					return false;

				case 'format':
					self.toolbar.find('.format_toolbar').toggleClass('format_toolbar-active');
					return false;

				case 'emoji':
					$(document).bind('menu_unload.once', () => self.restore_range());
					self.helper_emoji_select({
						type: 'left'
					});
					App.menu.in_editor = true;
					return false;

				case 'attach':
					let attach_btn = self.obj.parent().find('.editor-btn.attach:visible').get(0);
					let attach_menu_id = attach_btn.getAttribute('data-menu-id');

					if (attach_menu_id == null) return;

					if (attach_btn.btn_attach_timer != null) {
						clearTimeout(attach_btn.btn_attach_timer);
						attach_btn.btn_attach_timer = null;
						App.upload.attach.prepare_html();
						return;
					}

					clearTimeout(attach_btn.btn_attach_timer);
					attach_btn.btn_attach_timer = setTimeout(function () {
						attach_btn.btn_attach_timer = null;
						App.menu.show({anchor: attach_btn, box: '#' + attach_menu_id, type: 'fixed right2'});
						App.menu.in_editor = true;
					}, 270)

					return false;

				case 'ai':
					if (self.menu_ai != null) self.menu_ai.removeWithComponents();
					self.menu_ai = $('<div>', {
						class: 'menu menu-secondary menu-editorToolbar',
						html: self.obj.find('.editor__toolbar-ai').html()
					});

					self.menu_ai.find('a[data-btn]').not('[onclick]').once_by_criteria('editor_button_click').bind('mousedown', function (e) {
						e.preventDefault();
						let html = self.body.html();
						self.ai_selection = false;
						if (self.selection().toString()) {
							self.expandSelectionToBlock();
							html = self.getSelectionHTML();
							self.save_range();
							self.ai_selection = true;
						}
						self.obj.addClass('ai_loading');
						App.modal.show({
							url: App.helper.endpoint.primary() + '?' + App.actions.get('ai_helper:show'),
							backup: true,
							post: true,
							post_data: {
								text: html,
								subaction: $(this).attr('data-ai-type'),
							},
							success: function (response) {
								self.obj.removeClass('ai_loading');
							}
						});
						App.menu.hide();
						return false;
					});

					App.menu.show({
						anchor: self.obj.find('.editor__toolbar .ai:visible').get(0),
						box: self.menu_ai.get(0)
					});
					return false;
				case 'more':

					if (self.menu_more == null) {
						self.menu_more = $('<div>', {
							class: 'menu menu-secondary menu-editorToolbar',
							html: self.obj.find('.editor__toolbar-menu').html()
						});
					} else {
						self.menu_more.html(self.obj.find('.editor__toolbar-menu').html());
					}

					self.menu_more.find('a[data-btn]').not('[onclick]').once_by_criteria('editor_button_click').bind('mousedown', function (e) {
						e.preventDefault();
						return self.button($(this).attr('data-btn'));
					});

					App.menu.show({
						anchor: self.obj.find('.editor__toolbar .more:visible').get(0),
						box: self.menu_more.get(0),
						force_dropdown: true,
					});
					return false;
			}
			self.update();
		},

		is_toolbar_shown: function () {
			return self.body.parent().hasClass('with-topToolbar');
		},
		show_toolbar: function () {
			if (self.is_toolbar_shown()) return;
			self.toggle_toolbar(true);
		},
		// перемикає тулбар БЕЗ запам'ятовування стану
		toggle_toolbar: function (state) {
			self.body.parent().toggleClass('with-topToolbar', Boolean(state));
			// self.update();

			const button_processor = function () {
				const is_act = self.is_toolbar_shown();

				$(this).toggleClass('btn_act', is_act);

				if (is_act) {
					$(this).find('ws-icon').attr('name', 'editor/text_formatting-style');
				} else {
					$(this).find('ws-icon').attr('name', 'editor/text_formatting');
				}
			};
			self.obj.find('.editor__toolbar a.toolbar, .editor__toolbar-menu a.toolbar').add('.menu-editorToolbar a.toolbar').each(button_processor);
		},
		restore_toolbar_state: function () {
			App.classes.ui_state_manager.getInstance().loadState({
				onLoaded(state) {
					if (App.device.is_lg_width()) self.toggle_toolbar(state.editor_toolbar);
				}
			});
		},

		clean_onkeydown: function () { // This should clean bad html generated by chrome
			let range = self.range();
			if (range.collapsed && range.endContainer.nodeType === Node.TEXT_NODE && range.endContainer.length == range.endOffset) {
				if (range.endContainer.parentNode.nodeName.toLowerCase() == 'span') {
					node = range.endContainer.parentNode;
					if (node.style.fontStyle) {
						self.cursor_toend($('<i></i>').insertBefore(node).append(range.endContainer).get(0));
						$(node).remove();
					} else if (node.style.fontWeight) {
						self.cursor_toend($('<b></b>').insertBefore(node).append(range.endContainer).get(0));
						$(node).remove();
					} else if (node.style.textDecoration) {
						self.cursor_toend($('<strike></strike>').insertBefore(node).append(range.endContainer).get(0));
						$(node).remove();
					} else if (node.style.color && !self.color_regexp_dark.test(node.style.color)) {  // Something going wrong
						rem_node = range.endContainer;
						$(range.endContainer).insertAfter(node);
						$(node).remove();
						self.cursor_after(rem_node);
					}
				}
				if (range.endContainer.parentNode.nodeName.toLowerCase() == 'font') {
					node = range.endContainer.parentNode;
					if (node.style.color || node.style.backgroundColor) {
						self.cursor_toend($('<span/>').insertBefore(node).append(range.endContainer).attr('style', $(node).attr('style')).get(0));
						$(node).remove();
					}
				}
			}
		},

		clean: function () {
			let tmp_css, tmp_css2, do_cont, new_text,
				tagsForRemove = 'img, input, textarea, select, meta, link, style, script, embed, applet, param, iframe, ws-icon[name="tickBox-full"]';

			window.stop_wordclean = 0;
			self.body.find('img').each(function () { // FF clipborad
				if (window.ignore_img_clean) {
					$(this).remove();
				} else if (/^data:(image\/[^;]+);base64,(.*)$/.test($(this).attr('src'))) {
					let mimetype = RegExp.$1;
					let file = self.base64toBlob(RegExp.$2, mimetype);
					let ext = 'image';
					if (mimetype === 'image/png') ext = 'png';
					else if (mimetype === 'image/gif') ext = 'gif';
					else if (mimetype === 'image/jpeg') ext = 'jpg';
					let file_name = 'clip_' + App.helper.random.clipnum();
					App.upload.clipboard.start(file, file_name + '.' + ext);
					$(this).before("\u200b" + '<a href="clip:' + encodeURIComponent(file_name) + '" class="inline_file">' + file_name + '</a>' + "\u00a0");
					$(this).remove();
					window.stop_wordclean = 1;
				} else if (/^webkit-fake-url/.test($(this).attr('src'))) {
					$(this).remove();
				} else {
					if (!window.ignore_img_clean && $(this).width() > 200 && $(this).height() > 200) {
						$(this).replaceWith($(this).attr('src') + ' ');
					} else {
						$(this).remove();
					}
				}
			});
			window.ignore_img_clean = 0;
			if (window.stop_wordclean) return false;

			self.body.find('.time_space').remove();
			self.body.find(tagsForRemove).remove();

			self.body.find('font').each(function () {
				$('<span/>').append($(this).contents()).insertBefore(this).attr('style', $(this).attr('style'));
				$(this).remove();
			});
			self.body.find('td, p, span, font, div, li, ul').each(function () {
				if ($(this).attr('class') && $(this).attr('class').indexOf('hljs') !== -1) $(this).removeAttr('class'); else {
					if ($(this).css('font-style') == 'italic') $(this).wrapInner('<i></i>');
					if ($(this).css('font-weight') == 'bold' || $(this).css('font-weight') == 700) $(this).wrapInner('<b></b>');
					if ($(this).css('text-decoration') == 'line-through') $(this).wrapInner('<strike></strike>');
				}
			});
			self.body.find('td p, th p, dd, dt').each(function () {
				if (!/^(\s|&nbsp;|<br[^>]*>)*$/.test($(this).html())) $(this).contents().insertBefore($(this)).after('<br>');
				$(this).remove();
			});
			self.body.find('h1, h2, h3, h4, h5, h6').each(function () {
				$(this).replaceWith('<p><b>' + $(this).html() + '</b></p>');
			});
			self.body.find('s').each(function () {
				$(this).replaceWith('<strike>' + $(this).html() + '</strike>');
			});
			let allowed_tags = 'div, p, b, i, ul, ol, li, address, blockquote, br, span, font, strike, a[href], pre, em-emoji, ws-emoji, hr, ws-icon, svg, use, scode, task-stage';
			if (!self.body.attr('data-tables')) {
				self.body.find('td, th').each(function () {
					if (!/^(\s|&nbsp;|<br[^>]*>)*$/.test($(this).html())) {
						if (!/<(div|p)/i.test($(this).html())) $(this).contents().insertBefore($(this).parents('table')).after('<br>');
						else $(this).contents().insertBefore($(this).parents('table'));
					}
				});
				self.body.find('table').remove();
			} else {
				allowed_tags = allowed_tags + ', table, tr, td, th, tbody';
				self.body.find('table').attr('spellcheck', false).attr('contenteditable', false).each(function () {
					if (self.dom_helper.is_last(this)) $(this).after('<br>');
					if (self.dom_helper.is_first(this)) $(this).before(document.createTextNode("\u200b"));
				});
			}

			self.body.find(tagsForRemove).remove();
			self.body.find('*').not(allowed_tags).each(function () {
				$(this).contents().insertBefore($(this));
			});

			self.body.find('span, font').not('.invite, .contact, .join').each(function () {
				if (this.id == 'clip_upload') return false;
				if (
					(!$(this).css('background-color') || !self.color_regexp_light.test($(this).css('background-color'))) &&
					(!$(this).css('color') || !self.color_regexp_dark.test($(this).css('color'))) &&
					!$(this).parent().is('.inline_task')
				) {
					if (!$(this).hasClass('av_sm')) $(this).contents().insertBefore($(this));
					$(this).remove();
				}
			});
			do_cont = true;
			while (do_cont) {
				do_cont = false;
				self.body.children().find('div, p').each(function () {
					do_cont = true;
					self.dom_helper.replace_by_content(this);
				});
			}
			self.body.children('div').each(function () {
				if ($(this).find('address, blockquote, pre, ul, ol').length) {
					self.dom_helper.replace_by_content(this);
				}
			});
			do_cont = true;
			while (do_cont) {
				do_cont = false;
				self.body.children().find('address, blockquote, pre, ul, ol').each(function () {
					do_cont = true;
					if (!$(this).parent().is('ul, ol')) $(this).find('li').each(function () {
						self.dom_helper.replace_by_content(this);
					});
					self.dom_helper.replace_by_content(this);
				});
			}

			self.body.find('div, p, li, ol, ul, span, a, b, i, strike').addBack().contents().each(function () {
				if (this.nodeType === Node.TEXT_NODE) {
					new_text = this.textContent.replace(/ +/g, ' ');
					if (new_text != this.textContent) this.textContent = new_text;
				}
			});

			self.body.find('*').each(function () {
				let me = this;
				if (this.nodeName === 'IMG' && $(this).parent().prop('nodeName') === 'WS-EMOJI') {
					if (this.attributes.length) {
						$.each(this.attributes, function () {
							if (!/(src|alt|style)/.test(this.name)) $(me).removeAttr(this.name);
						});
					}
					return false;
				}
				tmp_css = $(this).css('background-color');
				tmp_css2 = $(this).css('color');
				if ($(this).attr('style') && this.nodeName !== 'WS-ICON') $(this).removeAttr('style');
				if (tmp_css && self.color_regexp_light.test(tmp_css)) $(this).css({'background-color': tmp_css});
				if (tmp_css2 && self.color_regexp_dark.test(tmp_css2)) $(this).css({'color': tmp_css2});
				if ($(this).attr('class') && !/^(todo|invite|contact|join|inline_file|inline_task|tag)/.test($(this).attr('class'))) $(this).removeAttr('class');
				if (this.attributes.length) {
					let rm_attr = [];
					$.each(this.attributes, function () {
						if (me.nodeName === 'WS-EMOJI' && /(id|native)/.test(this.name)) return;
						if (/(class|contenteditable|spellcheck|style|href|rel|data-txt|colspan|rowspan|name)/.test(this.name)) return;

						rm_attr.push(this.name);
					});

					for (let i in rm_attr) {
						$(this).removeAttr(rm_attr[i]);
					}
				}
			});

			self.body.find('a').not('.inline_task').each(function () {
				$(this).toggleClass('inline_file', self.is_inline_file($(this).attr('href')));
			});

			self.body.find('scode').attr('spellcheck', false);
			self.mention.clean();
			self.contact.clean();

			self.body.find('ws-emoji').each(function() {
				if (this.shadowRoot == null) {
					$(this).replaceWith($(this).clone());
				}
			});

			window.wait_autoresize = 0;
			self.need_clean = self.body.find('*').not('div, p, br, .av_sm').length > 0;
			self.mention.sync();
			self.update();
		},

		update_button_title: function (el) {
			let key = $(el).attr('data-btn');
			let index = $(el).hasClass('btn_act') ? 1 : 0;
			let title = App.object_state.locale.editor.names[key];
			let hotkey = App.object_state.locale.editor.hotkeys[key];

			if (title == null && hotkey == null || $(el).hasClass('menu__item')) return;

			let text = title instanceof Array ? title[index] : title;

			text = typeof text === 'string' ? text.trim() : '';

			if (hotkey != null) {
				hotkey = hotkey instanceof Array ? hotkey : [hotkey];
				text += '\n%K' + hotkey.join('K% %K') + 'K%';
			}

			$(el).attr('data-title', text.trim());
		},

		update: function () {
			let is_act;
			self.save();

			let tree = $(self.getParentElement()).parents().addBack();
			let is_list = self.button_state('insertorderedlist') || (tree.filter('ol').length > 0);
			let is_todo = is_list && (tree.filter('ol.todo').length > 0);

			let button_processor = function () {
				switch ($(this).attr('data-btn')) {
					case 'bold':
					case 'italic':
					case 'underline':
					case 'strikethrough':
						$(this).toggleClass('btn_act', self.button_state($(this).attr('data-btn')));
						break;
					case 'quote':
						$(this).toggleClass('btn_act', /^(add?r|адр)/.test((self.button_value('formatblock')).toLowerCase()));
						break;
					case 'inline_code':

						if (self.selection().toString().trim().split('\n').length > 1) {
							$(this).addClass('menu__item-disabled').removeClass('btn_act');
						} else {
							$(this).removeClass('menu__item-disabled').toggleClass('btn_act', tree.filter('scode').length > 0);
						}

						break;
					case 'code':
						$(this).toggleClass('btn_act', /^(pre|код)/.test((self.button_value('formatblock')).toLowerCase()));
						break;
					case 'list_bullet':
						$(this).toggleClass('btn_act', self.button_state('insertunorderedlist') || (tree.filter('ul').length > 0));
						break;
					case 'list_num':
						$(this).toggleClass('btn_act', is_list && !is_todo);
						break;
					case 'list_todo':
						$(this).toggleClass('btn_act', is_list && is_todo);
						break;
					case 'color_bg':
						let bc = '', is_colored = false,
							command = $.browser.msie || $.browser.webkit ? "backcolor" : "hilitecolor",
							prop = 'backgroundColor';

						if ($('body').attr('data-color')) {
							command = 'foreColor';
							prop = 'color';
						}
						if (!self.selection().toString().length) {
							bc = self._makeColor(self.button_value(command));
						} else if ($(self.getParentElement()).is('span')) {
							bc = $(self.getParentElement()).css('backgroundColor');
						}

						if (bc !== '') is_colored = ($('body').attr('data-color') ? self.color_regexp_dark : self.color_regexp_light).test(bc);
						if (is_colored) {
							$(this).addClass('btn_act').css($('body').attr('data-color') ? {borderColor: bc} : {
								backgroundColor: bc,
								borderColor: bc
							});
						} else {
							if ($(this).attr('style')) $(this).removeClass('btn_act').removeAttr('style');
						}
						break;
					case 'link':
						$(this).toggleClass('btn_act', $(self.getParentElement()).parents().addBack().filter('a').length > 0);
						break;
					case 'clean':
						$(this).toggleClass('btn_act', self.need_clean).toggleClass('menu__item-disabled', !self.need_clean);
						break;
					case 'format':
						$(this).toggleClass('btn_act', self.toolbar.find('.format_toolbar').hasClass('format_toolbar-active'));
						break;
					case 'toolbar':
						is_act = self.is_toolbar_shown();

						$(this).toggleClass('btn_act', is_act);

						if (is_act) {
							$(this).find('ws-icon').attr('name', 'editor/text_formatting-style');
						} else {
							$(this).find('ws-icon').attr('name', 'editor/text_formatting');
						}
						break;
					case 'ai':
						is_act = self.body.text().length > 20;
						$(this).toggle(is_act);
						break;
					case 'undo':
						$(this).toggleClass('btn_act', self._undoPos[self.num()] > 0).toggleClass('btn_preact', self._undoMax[self.num()] > 0);
						$(this).toggleClass('menu__item-disabled', !$(this).hasClass('btn_act'));
						break;
					case 'redo':
						$(this).toggleClass('btn_act', self._undoPos[self.num()] < self._undoMax[self.num()]);
						$(this).toggleClass('menu__item-disabled', !$(this).hasClass('btn_act'));
						break;
					case 'delete':
						let has_draft = self._undoMax[self.num()] > 0 || $('#draft_del').hasClass('draft_del_act');
						$(this).toggleClass('btn_act', has_draft).toggleClass('menu__item-disabled', !has_draft).toggleClass('menu__item-delete', has_draft);
						break;
					case 'save':
						let has_body = self._undoMax[self.num()] > 0 || self._undoPos[self.num()] > 0;
						$(this).toggleClass('btn_act', has_body).toggleClass('menu__item-disabled', !has_body);
						break;
				}
				self.update_button_title(this);
			};

			let process_buttons = function () {
				self.obj.find('.editor__toolbar a, .editor__toolbar-menu a').add('.menu-editorToolbar a').each(button_processor);
				self.obj.find('.editor-btn.more').toggleClass('hiddenBlock', $('.editor__toolbar-menu a:not(.menu__item-disabled)').length === 0);
			}

			if (self._snapupd) {
				process_buttons()
			} else {
				self.save_snapshot(process_buttons)
			}
		},

		save_snapshot: App.helper.debounce(function (next) {
			self.snapshot();
			if (next) next();
		}, 500),

		css_style: function (yes) {
			try {
				document.execCommand("styleWithCSS", false, yes);
			} catch (e) {
			}
		},

		formatblock: function (value) {
			if ($.browser.msie) {
				if (value == 'blockquote') value = 'address';
				value = "<" + value + ">";
			}
			document.execCommand('formatblock', false, value);
		},

		set_color: function (color) {
			if (!self.is_active()) {
				self.body.focus();
				if (self.last_range) self.restore_range();
			}
			if (color) self.last_color = color;
			self.need_clean = true;

			// Check if selection includes special elements
			let range = self.range(self.selection());
			const specialElements = ".invite, .contact, .inline_task";

			if (range && !range.collapsed) {
				let container = range.commonAncestorContainer;
				let checkElement = container.nodeType === Node.TEXT_NODE ? container.parentNode : container;
				// Check the container itself and all its descendants
				if ($(checkElement).is(specialElements) || $(checkElement).closest(specialElements).length) return;

				// Check start and end nodes of the selection
				let startNode = range.startContainer;
				let endNode = range.endContainer;
				if (startNode.nodeType === Node.TEXT_NODE) startNode = startNode.parentNode;
				if (endNode.nodeType === Node.TEXT_NODE) endNode = endNode.parentNode;
				if ($(startNode).is(specialElements) || $(startNode).closest(specialElements).length ||
					$(endNode).is(specialElements) || $(endNode).closest(specialElements).length) return;
			}

			let bc = '';
			let is_colored = false;
			let command = $.browser.msie || $.browser.webkit ? "backcolor" : "hilitecolor";
			let prop = 'backgroundColor';
			if ($('body').attr('data-color')) {
				command = 'foreColor';
				prop = 'color';
			}
			if (!self.selection().toString().length) {
				bc = self._makeColor(self.button_value(command));
			} else if ($(self.getParentElement()).is('span') && $(self.getParentElement()).text() === self.selection().toString()) {
				bc = $(self.getParentElement()).css('backgroundColor');
			}

			if (bc !== '') is_colored = ($('body').attr('data-color') ? self.color_regexp_dark : self.color_regexp_light).test(bc);

			if (is_colored) {
				let parent = self.getParentElement();
				if ($(parent).is(specialElements) || $(parent).closest(specialElements).length) return;
				while (parent && parent.style && !parent.style[prop] && parent.parentNode) parent = parent.parentNode;
				if (parent && parent.style) {
					if ($(parent).is(specialElements) || $(parent).closest(specialElements).length) return;
					if (parent.tagName.toLowerCase() == "span" && !color) {
						while (parent.firstChild) parent.parentNode.insertBefore(parent.firstChild, parent);
						parent.parentNode.removeChild(parent);
					} else parent.style[prop] = color;
				}
			} else {
				if (!color) color = null;
				document.execCommand(command, false, color);
				self.body.find('font').each(function () {
					$('<span/>').append($(this).contents()).insertBefore(this).attr('style', $(this).attr('style'));
					$(this).remove();
				});
				self.body.find('span span').each(function () {
					if ($(this).is(specialElements) || $(this).parent().is(specialElements)) return;
					if ($(this).css(prop) && $(this).parent().is('span') && $(this).parent().css(prop)) {
						if (this.nextSibling) {
							let span = document.createElement('span');
							span.style = $(this).parent().attr('style');
							$(span).insertAfter($(this).parent());
							while (this.nextSibling) span.appendChild(this.nextSibling);
						}
						if ($(this).css(prop) == 'rgb(255, 255, 255)') {
							$(this).contents().insertAfter($(this).parent());
							$(this).remove();
						} else {
							$(this).insertAfter($(this).parent());
						}
					}
				});
				self.body.find('span').each(function () {
					if ($(this).is(specialElements)) return;
					if ($(this).css(prop) == 'rgb(255, 255, 255)' && !$(this).parents().filter('span').length) {
						$(this).contents().insertAfter(this);
						$(this).remove();
					}
				});
			}

			// merge same colors:
			self.body.find('span').each(function () {
				if (!this.nextSibling || $(this).is(specialElements)) return;

				let next = this.nextSibling, remove = [];

				if (next.nodeType === Node.TEXT_NODE) {
					if (next.nodeValue.replaceAll("\u200b", "") === '') {
						remove.push(next);
						next = next.nextSibling;
					} else {
						next = null;
					}
				}

				if (next == null || next.nodeType !== 1 || next.tagName !== 'SPAN' || $(next).is(specialElements)) return;

				if ($(this).css(prop) === $(next).css(prop)) {
					$(next).prepend($(this).contents());
					$(this).remove();
					remove.forEach(i => $(i).remove())
				}
			});

			self.body.get(0).normalize();
			range = self.range(self.selection());
			if (!range.collapsed && range.endContainer.nodeType === Node.TEXT_NODE && range.endContainer.length == range.endOffset) {
				if (range.endContainer.parentNode) {
					range.setEndAfter(range.endContainer.parentNode);
					range.collapse(false);
					range.insertNode(document.createTextNode("\u200b"));
					range.collapse(false);
				} else range.collapse(false);
				self.selection().removeAllRanges();
				self.selection().addRange(range);
			}


			// self.update();
			if (color) {
				self.obj.find('.editor__toolbar .color_bg').addClass('btn_act').css($('body').attr('data-color') ? {borderColor: bc} : {
					backgroundColor: bc,
					borderColor: bc
				});
			} else {
				self.obj.find('.editor__toolbar .color_bg').removeClass('btn_act').css($('body').attr('data-color') ? {borderColor: 'transparent'} : {
					backgroundColor: 'transparent',
					borderColor: 'transparent'
				});
			}
			self.update();
		},

		set_link: function (param, text) {
			self.need_clean = true;
			self.restore_range();
			let a = $(self.getParentElement()).parents().addBack().filter('a');
			let sel = self.selection();
			if (!param) {
				if (!sel.toString().length) a.replaceWith(a.contents());
				else {
					document.execCommand("unlink", false);
					sel.collapseToEnd();
				}
				self.body.find('a').each(function () {
					if (!$(this).html() || $(this).html() == "\u200b") $(this).remove();
				});
				self.body.find('span.inline_file').each(function () {
					$(this).replaceWith($(this).contents());
				});
				self.body.get(0).normalize();
				self.update();
				return false;
			}
			if (!/^([a-z]+:)?\/\//.test(param) && !/^[a-z]+:/.test(param)) param = 'https://' + param;
			if (a.length) {
				a.attr('href', param).html(text || param);
			} else if (sel.toString().length) {
				document.execCommand("createlink", false, param);
				sel.collapseToEnd();
				let range = self.range(sel);
				a = $(range.endContainer).parents().addBack().filter('a').get(0);
				if (a) {
					$(a).html(text || param);
					if (!a.nextSibling || (a.nextSibling.nodeType !== 3 && self.dom_helper.is_block_or_br(a.nextSibling))) $(a).after(document.createTextNode("\u200b"));
					self.cursor_after(a);
				} else {
					sel.collapseToEnd();
				}
			} else {
				self.insert($('<a></a>').attr('href', param).html(text || param).get(0), true);
			}
			self.body.find('a').not('.inline_task').each(function () {
				$(this).toggleClass('inline_file', self.is_inline_file($(this).attr('href')));
			});
			self.body.get(0).normalize();
			self.update();
			setTimeout(function () {
				self.body.focus();
			}, 100);
		},

		selection: function () {
			return window.getSelection();
		},

		range: function (sel) {
			if (!sel) sel = self.selection();
			try {
				return sel.getRangeAt(0);
			} catch (e) {
				return document.createRange();
			}
		},

		getParentElement: function () {
			let range = self.range();
			try {
				let p = range.commonAncestorContainer;
				if (!range.collapsed && range.startContainer === range.endContainer && range.startOffset - range.endOffset <= 1 && range.startContainer.hasChildNodes()) p = range.startContainer.childNodes[range.startOffset];
				while (p.nodeType === Node.TEXT_NODE) p = p.parentNode;
				return p;
			} catch (e) {
				return null;
			}
		},

		save_range: function (rem_selection) {
			if (rem_selection) self.rem_range = self.range();
			if (self.is_active()) self.last_range = self.range();
		},

		restore_range: function () {
			// if (self.rem_range) {
			//   self.last_range = self.rem_range;
			//   self.rem_range = null
			// }
			if (!self.last_range) return self.cursor_toend();
			sel = self.selection();
			sel.removeAllRanges();
			sel.addRange(self.last_range);
		},

		insert_text: function (html, and_select) {
			let range = self.range(), node;
			if (!range.collapsed) range.deleteContents();
			range.insertNode(node = document.createTextNode(html));

			if (and_select === true) {
				range.setStartBefore(node);
				range.setEndAfter(node);
			} else {
				range.setEndAfter(node);
				range.setStartAfter(node);
			}

			self.selection().removeAllRanges();
			self.selection().addRange(range);
		},

		insert: function (span, rem_selection) {
			if (!self.is_active()) self.restore_range();
			let sel;
			let range = self.range(sel = self.selection());
			if (rem_selection && self.rem_range) {
				// ніби все працює і без цього, прибрав, бо викликало баг #8319991/#com20806163
				// if (self.rem_range.startContainer !== range.startContainer && range.startContainer.nodeType === Node.TEXT_NODE) {
				// 	range.setStart(range.startContainer, 0); // Bug after insert invite
				// } else {
				// 	range.setStart(self.rem_range.startContainer, self.rem_range.startOffset);
				// }
				range.setStart(self.rem_range.startContainer, self.rem_range.startOffset);
				range.deleteContents();
				self.rem_range = null;
			}
			if (rem_selection) self.need_clean = true;
			range.insertNode(document.createTextNode("\u00a0")); // u200b - zero space u00a0 -- nbsp
			range.insertNode(span);
			if (!span.previousSibling || self.dom_helper.is_block_or_br(span.previousSibling)) {
				$(span).before(document.createTextNode("\u200b"));
			} else if (span.previousSibling.nodeType !== 3 || !/\s$/i.test(span.previousSibling.textContent)) {
				if (!self.dom_helper.is_hr(span)) $(span).before(document.createTextNode("\u00a0"));
			}
			range.endContainer.normalize();
			range.collapse(false);
			sel.removeAllRanges();
			sel.addRange(range);
			self.input_tracked = false ;
			self.save_range();
			self.update();
			//setTimeout(function() { self.obj.focus(); }, 10);
		},

		clear_selection: function () {
			if (!self.rem_range) return;
			let range = self.range();
			if (self.rem_range.startContainer !== range.startContainer && range.startContainer.nodeType === Node.TEXT_NODE) range.setStart(range.startContainer, 0); // Bug after insert invite
			else range.setStart(self.rem_range.startContainer, self.rem_range.startOffset);
			range.deleteContents();
			self.rem_range = null;
		},

		cursor_after: function (el) {
			if (!el) return false;
			let range = self.range();
			range.setEndAfter(el);
			range.setStartAfter(el);
			self.selection().removeAllRanges();
			self.selection().addRange(range);
		},

		cursor_before: function (el) {
			if (!el) return false;
			let range = self.range();
			range.setEndBefore(el);
			range.setStartBefore(el);
			self.selection().removeAllRanges();
			self.selection().addRange(range);
		},

		cursor_toend: function (el) {
			range = self.range();

			if (!el) {
				el = self.dom_helper.find_last_text_node(self.body.get(0));
				if (!el) el = self.body.get(0);
			}
			if (!el) return;

			if (el.nodeType === Node.TEXT_NODE) {
				range.setStart(el, el.textContent.length);
				range.setEnd(el, el.textContent.length);
			} else if (self.dom_helper.is_br(el.childNodes[el.childNodes.length - 1]) && self.dom_helper.is_block(el)) {
				range.setStart(el, el.childNodes.length - 1);
				range.setEnd(el, el.childNodes.length - 1);
			} else {
				range.setStart(el, el.childNodes.length);
				range.setEnd(el, el.childNodes.length);
			}
			self.selection().removeAllRanges();
			self.selection().addRange(range);
		},

		cursor_wrap: function (el) {
			range = document.createRange();
			//range.selectNodeContents(el);
			range.selectNode(el);
			self.selection().removeAllRanges();
			self.selection().addRange(range);
			//node.appendChild(document.createTextNode("\u200b"));
		},

		cursor_at_word_begin: function () { // This should clean bad html generated by chrome
			range = self.range();
			return range.collapsed && (range.endContainer.nodeType !== 3 || range.endOffset === 0 || /\s/.test(range.endContainer.textContent[range.endOffset - 1]));
		},

		//-----------------------------------------------------------------------
		//
		//   Undo / Redo
		//
		//-----------------------------------------------------------------------

		_snapupd: false,
		snapshot: function () {
			++self._undoPos[self.num()];
			if (self._undoPos[self.num()] >= 50) {
				self._undoQueue[self.num()].shift();
				self._undoCursor[self.num()].shift();
				--self._undoPos[self.num()];
			}
			let txt;
			if (self.is_active()) {
				range = self.range();
				offset = range.endOffset;
				node = range.endContainer;
				if (node.nodeType === Node.TEXT_NODE) {
					while (node.previousSibling && node.previousSibling.nodeType === Node.TEXT_NODE) {
						node = node.previousSibling;
						offset += node.textContent.length;
					}
					if (node.previousSibling) $(node = node.previousSibling).attr('data-cur', 'after'); else $(node = node.parentNode).attr('data-cur', 'in');
				} else if (!offset) {
					if (node.nodeName.toLowerCase() == 'br') $(node).attr('data-cur', 'after'); else $(node).attr('data-cur', 'in');
				} else {
					node = node.childNodes[offset - 1];
					if (node.nodeType === Node.TEXT_NODE) {
						offset = node.textContent.length;
						while (node.previousSibling && node.previousSibling.nodeType === Node.TEXT_NODE) {
							node = node.previousSibling;
							offset += node.textContent.length;
						}
						if (node.previousSibling) $(node = node.previousSibling).attr('data-cur', 'after'); else $(node = node.parentNode).attr('data-cur', 'in');
					} else $(node).attr('data-cur', 'after');
				}
				txt = self.body.html();
				$(node).removeAttr('data-cur');
			} else {
				txt = self.body.html();
				offset = 0;
			}

			if (isNaN(self._undoPos[self.num()])) return; // TODO: check why it is NaN when page reloading sometimes

			if (self._undoPos[self.num()] <= 0 || self._undoQueue[self.num()][self._undoPos[self.num()] - 1].replace(/ data-cur="[^"]*"/g, '') != txt.replace(/ data-cur="[^"]*"/g, '')) {
				self._undoQueue[self.num()][self._undoPos[self.num()]] = txt;
				self._undoCursor[self.num()][self._undoPos[self.num()]] = offset;
				self._undoMax[self.num()] = self._undoPos[self.num()];
			} else self._undoPos[self.num()]--;
		},

		undo: function () {
			if (self._undoPos[self.num()] > 0) {
				let txt = self._undoQueue[self.num()][--self._undoPos[self.num()]];
				self.init_from_html(txt.replace('#WSCUR#', '<span id="wscur"></span>'), 'snapshot');
				if (!App.device.is_mobile()) self.cursor_restore();
				self.mention.sync();
				self._snapupd = true;
				self.update();
				self._snapupd = false;
			}
		},

		redo: function () {
			if (self._undoPos[self.num()] < self._undoMax[self.num()]) {
				let txt = self._undoQueue[self.num()][++self._undoPos[self.num()]];
				self.init_from_html(txt.replace('#WSCUR#', '<span id="wscur"></span>'), 'snapshot');
				if (!App.device.is_mobile()) self.cursor_restore();
				self.mention.sync();
				self._snapupd = true;
				self.update();
				self._snapupd = false;
			}
		},

		_undoQueue: [],
		_undoCursor: [],
		_undoPos: [],
		_undoMax: [],

		undo_init: function () {
			self._undoQueue[self.num()] = Array(50);
			self._undoCursor[self.num()] = Array(50);
			self._undoPos[self.num()] = -1;
			self._undoMax[self.num()] = -1;
		},

		cursor_restore: function () {
			offset = self._undoCursor[self.num()][self._undoPos[self.num()]];
			cur = self.body.find('[data-cur]').get(0);
			if (!cur) cur = self.body.get(0);
			if ($(cur).attr('data-cur') == 'after') {
				$(cur).removeAttr('data-cur');
				if (!offset) self.cursor_after(cur);
				cur = cur.nextSibling;
			} else {
				$(cur).removeAttr('data-cur');
				if (!offset) {
					range = self.range();
					range.setStart(cur, offset);
					range.setEnd(cur, offset);
					self.selection().removeAllRanges();
					self.selection().addRange(range);
					return false;
				}
				cur = cur.childNodes[0];
			}
			while (cur && cur.nodeType === Node.TEXT_NODE) {

				if (cur.textContent.length == offset) {
					range = self.range();
					range.setStartAfter(cur);
					range.setEndAfter(cur);
					self.selection().removeAllRanges();
					self.selection().addRange(range);
					return false;
				}
				if (cur.textContent.length > offset) {
					range = self.range();
					range.setStart(cur, offset);
					range.setEnd(cur, offset);
					self.selection().removeAllRanges();
					self.selection().addRange(range);
					return false;
				}
				offset -= cur.textContent.length;
			}
		},

		stop_tracking: function () {
			self.input_tracked = false;
			self.rem_range = null;
		},

		//-----------------------------------------------------------------------
		//
		//   Binded editor events
		//
		//-----------------------------------------------------------------------

		oncut: function (e) {
			self.mention.sync();
		},

		onpaste: function (e) {
			if (e.originalEvent) e = e.originalEvent;
			if (e && e.clipboardData && e.clipboardData.items) {
				for (let i = 0; i < e.clipboardData.items.length; i++) {
					let item = e.clipboardData.items[i];
					if (item.type === 'text/rtf') break;
					if (item.type.indexOf("image") !== -1) {
						let file = item.getAsFile();
						let ext = 'image';
						if (item.type === 'image/png') ext = 'png';
						else if (item.type === 'image/gif') ext = 'gif';
						else if (item.type === 'image/jpeg') ext = 'jpg';
						let file_name = 'clip_' + App.helper.random.clipnum();
						self.insert($('<a class="inline_file" href="clip:' + file_name + '">' + file_name + '</a>').get(0));
						e.preventDefault();
						App.upload.clipboard.start(file, file_name + '.' + ext);
						window.stop_wordclean = 1;
						window.ignore_img_clean = 1;
						return false;
					}
				}
			}
			if (!$(self.range().startContainer).parents().addBack().filter('pre').length) {
				let txt = window.clipboardData ? window.clipboardData.getData('text') : (e.originalEvent || e).clipboardData.getData('text/plain');
				txt = txt.trim();
				if (txt.match(/^(ftps?|https?):\/\/[a-z01-9#\?\=\-_\.,\/&%\+:;@\!\[\]{}]+[a-z01-9#\?\=\-_\/&%\+:;\!\[\]{}]$/i) || txt.match(/^clip:[^ ]+$/)) {
					o = $('<a></a>').attr('href', txt).html(txt);
					if (self.is_inline_file(txt)) o.addClass('inline_file');
					self.insert(o.get(0));
					e.preventDefault();
					return false;
				}

				if (txt.match(/^#(\d+)$/i)) {
					let id_task = txt.substring(1);

					let node = self.task.create_dummy(id_task);
					self.insert(node);
					self.task.find_by_id(id_task, function (t) {
						node.replaceWith(t ? self.task.create_node(t) : txt)
					});

					e.preventDefault();
					return false;
				}
			}
			window.wait_autoresize = 1;
			if (window.killword) clearTimeout(window.killword);
			window.killword = setTimeout(function () {
				self.clean();
			}, 100);
			return true;
		},

		onkeyup: function (e) {
			let keyCode = e.which || e.keyCode || e.charCode;
			let keyEvent = e.type == "keypress";
			let key = String.fromCharCode(keyCode);
			self.clean_onkeydown();

			if (keyEvent && self.input_tracked != 0 && !App.device.is_mobile()) {
				if (self.input_tracked < 0) {
					self.input_tracked = -self.input_tracked;
				} else if (self.input_tracked == 1 && self.symbol_tracked !== '@') {
					self.input_sequential_text += key;
					if (self.input_sequential_text === '@') self.input_sequential_text = '';
					if (self.input_sequential_text === '"') self.input_sequential_text = '';
					if (self.input_sequential_text === '#') self.input_sequential_text = '';
					if (self.input_sequential_text === '№') self.input_sequential_text = '';
					App.context_search.menu.apply(self.input_sequential_text, App.menu.obj_window);
					if (App.context_search.letters_with_empty_result == 3) {
						self.stop_tracking();
						if (App.menu.in_editor) App.menu.hide();
					}
				} else if (self.input_tracked == 2) {
					self.input_sequential_text += key;
					if (self.input_sequential_text === '@') self.input_sequential_text = '';
					if (self.input_sequential_text === '"') self.input_sequential_text = '';
					if (self.input_sequential_text === '#') self.input_sequential_text = '';
					if (self.input_sequential_text === '№') self.input_sequential_text = '';
					App.menu.obj_window?.find('.switch_search_mode b').text(self.input_sequential_text);
					if (App.controls.task_select_and_go.is_server_mode) {
						App.controls.task_select_and_go.handle_server_search(self.input_sequential_text);
					} else {
						App.context_search.menu.apply(self.input_sequential_text, App.menu.obj_window, {callback: App.controls.task_select_and_go.draw_tree.bind(App.menu.obj_window)});
					}
					// if (App.context_search.letters_with_empty_result == 5) {
					// 	self.stop_tracking();
					// 	if (App.menu.in_editor) App.menu.hide();
					// }
				} else if (self.input_tracked == 3) {
					self.input_sequential_text += key;

					if (self.input_sequential_text === ':') self.input_sequential_text = '';

					App.controls.emoji.inline_menu.handleSearch(self.input_sequential_text);
				} else if (self.input_tracked == 4) { // for contacts
					self.input_sequential_text += key;
					if (self.input_sequential_text === '@') self.input_sequential_text = '';
					if (self.input_sequential_text === '"') self.input_sequential_text = '';
					if (self.input_sequential_text === '#') self.input_sequential_text = '';
					if (self.input_sequential_text === '№') self.input_sequential_text = '';

					if (self.input_sequential_text) {
						App.core.call_queue.add('editor_contact_search', App.controls.contact_select_and_go.helper_server_search, App.menu.obj_window, {
							search: self.input_sequential_text,
							request: {
								editor: 1,
								opt_mention: self.body.attr('data-mention') === 'on' ? 1 : 0,
								opt_task: self.body.attr('data-task') === 'on' ? 1 : 0,
							}
						}, 0.3);
					}
				}
			}
			if ($.browser.webkit && (e.ctrlKey || e.metaKey)) switch (key.toLowerCase()) {
				case 'b':
				case 'i':
				//case 's':
				case 'u':
					e.preventDefault();
					break;
			}

			if (keyCode === App.keycode.Backspace || keyCode === App.keycode.Delete) {
				self.mention.sync();
			}
		},

		num_spaces_sequential: 0,
		onkeydown: function (e) {
			let keyCode = e.which || e.keyCode || e.charCode;
			let key = String.fromCharCode(keyCode);
			let eKey = e.key || e.originalEvent.key;
			let range;
			if (e.type == 'textInput' && e.originalEvent && e.originalEvent.data && App.device.is_mobile()) {
				keyCode = 0;
				key = e.originalEvent.data;
				if (key === ' ') keyCode = App.keycode.Space;
				if (key === "\n") keyCode = App.keycode.Enter;
				// if (key == '@') { window.stop_ev_any = true; e.shiftKey = true; keyCode = 50;  }
				// if (key == '#') { window.stop_ev_any = true; e.shiftKey = true; keyCode = 51; }
			} else if (window.stop_ev_any) {
				window.stop_ev_any = false;
			}

			// begin deprecated hotkeys:
			if ((keyCode === App.keycode.SomeDivide || keyCode === App.keycode.NumpadDivide) && e.altKey) {
				e.preventDefault();
				self.button('quote');
			}
			if ((keyCode === App.keycode.Insert || keyCode === App.keycode.NumpadSubtract) && e.altKey) {
				e.preventDefault();
				self.button('list_bullet');
			}
			if ((keyCode === App.keycode.SomeMultiply || keyCode === App.keycode.NumpadMultiply) && e.altKey) {
				e.preventDefault();
				self.button('list_num');
			}
			if ((keyCode === App.keycode.SomeAdd || keyCode === App.keycode.NumpadAdd) && e.altKey && self.obj.find('.editor__toolbar .list_todo').length) {
				e.preventDefault();
				self.button('list_todo');
			}
			// end deprecated hotkeys;

			if (keyCode === App.keycode.Insert && e.shiftKey) {
				if (window.killword) clearTimeout(window.killword);
				window.killword = setTimeout(function () {
					if (!window.stop_wordclean) self.clean();
					window.stop_wordclean = false;
				}, 100);
			}

			if (!App.device.is_mobile()) {
				if (self.menu_show_timer) clearTimeout(self.menu_show_timer);

				if (self.input_tracked && keyCode === App.keycode.Enter && App.menu.in_editor && App.menu.inline_emoji_select) {
					e.preventDefault();
					App.controls.emoji.inline_menu.handleSelect();
					return true;
				}
				if (self.input_tracked && App.keycode.is_arrows(keyCode) && App.menu.in_editor && App.menu.inline_emoji_select) {
					e.preventDefault();
					App.controls.emoji.inline_menu.handleNav(
						keyCode === App.keycode.ArrowLeft ? -1 : (keyCode === App.keycode.ArrowRight ? 1 : 0),
						keyCode === App.keycode.ArrowUp ? -1 : (keyCode === App.keycode.ArrowDown ? 1 : 0),
					);
					return true;
				}

				if (self.input_tracked && (keyCode === App.keycode.Enter || keyCode === App.keycode.ArrowUp || keyCode === App.keycode.ArrowDown)) return true;
				if (self.input_tracked && (keyCode === App.keycode.Space || keyCode === App.keycode.Escape || (self.symbol_tracked !== '@' && (keyCode === App.keycode.ArrowLeft || keyCode === App.keycode.ArrowRight)))) {
					self.stop_tracking();
					if (App.menu.in_editor) {
						if (keyCode === App.keycode.Escape) {
							// трохи по хитрому - тут приберемо selected, щоб в App.keyboard.process_key зразу закрилось меню
							App.keyboard_selection.process_escape_key();
						} else {
							App.menu.hide();
						}
						return true;
					}
				} else if (self.body.attr('data-mention') && !self.input_tracked && (/*eKey === '@' || */eKey === '"') && self.cursor_at_word_begin()) { // @
					self.search_mode = false;
					self.symbol_tracked = eKey;
					self.input_tracked = -1;
					self.input_sequential_text = '';
					self.save_range(true);
					let text_position = self.getSelectionCoords();
					const show_mention_select = () => {
						self.helper_mention({ text_position, from_text: true });
						App.menu.in_editor = true;
					}
					if (eKey === '@') {
						show_mention_select();
					} else {
						self.menu_show_timer = setTimeout(show_mention_select, 630);
					}
				} else if (self.body.attr('data-task') && !self.input_tracked && (eKey === '#' || eKey === '№') && self.cursor_at_word_begin()) { // #
					self.search_mode = false;
					self.symbol_tracked = eKey;
					self.input_tracked = -2;
					self.input_sequential_text = '';
					self.save_range(true);
					let text_position = self.getSelectionCoords();
					const show_task_select = () => {
						self.helper_task_select({ text_position, from_text: true });
						App.menu.in_editor = true;
					};
					if (eKey === '#') {
						show_task_select();
					} else {
						self.menu_show_timer = setTimeout(show_task_select, 630);
					}
				} else if (!self.input_tracked && eKey === ':' && self.cursor_at_word_begin()) { // :
					self.search_mode = false;
					self.symbol_tracked = eKey;
					self.input_tracked = -3;
					self.input_sequential_text = '';
					self.save_range(true);
					let text_position = self.getSelectionCoords();
					self.helper_emoji_select({
						text_position,
						from_text: true
					});
					App.menu.inline_emoji_select = true;
					App.menu.in_editor = true;
				}
			}

			if (keyCode === App.keycode.Enter && !App.menu.in_editor && !e.ctrlKey) { // exit from quotes and code by enter
				range = self.range();

				if ($(range.endContainer).parents().addBack().filter('scode').length) {

					const txt = document.createTextNode("\u00a0");
					$(txt).insertAfter($(range.endContainer).parents().addBack().filter('scode').get(0));
					self.cursor_after(txt);
					txt.parentNode.normalize();

					e.preventDefault();
					return false;
				}

				is_li = $(range.endContainer).parents().addBack().filter('li').length;
				if (range.collapsed) {
					node = null;
					is_last = false;
					is_first = false;
					if (range.endContainer.nodeType === Node.TEXT_NODE) {  // Last Node in TagDB
						node = range.endContainer;
						is_last = range.endOffset == range.endContainer.textContent.length;
						is_first = range.endOffset === 0;
					} else if (range.endContainer.nodeType !== 3 && range.endOffset > 0) {
						node = range.endContainer.childNodes[range.endOffset - 1];
						is_last = true; //node && self.dom_helper.is_last(node);
					} else if (range.endContainer.nodeType !== 3 && range.endOffset === 0) {
						is_first = true;
					}
					if (!node) { // No children at all
						if (is_li) return true;
						if (self.dom_helper.is_quote(range.endContainer)) {
							node = range.endContainer;
							self.cursor_before(range.endContainer);
							$(node).remove();
							e.preventDefault();
							self.onheight(true);
							return false;
						}
					} else if (is_last && !e.shiftKey) {
						while (self.dom_helper.is_inline(node.parentNode) && self.dom_helper.update_inline_br(node.parentNode) && self.dom_helper.is_last(node)) node = node.parentNode;
						//if (is_li && !(self.dom_helper.is_last(node) || self.dom_helper.is_last_inFF(node))) e.shiftKey = true;
						if (!e.shiftKey) { // After some node
							if (is_li) return true;
							else if (self.dom_helper.is_quote(node.parentNode) && self.dom_helper.is_br(node) && (self.dom_helper.is_last(node) || self.dom_helper.is_last_inFF(node))) {
								self.cursor_before($('<br>').insertAfter(node.parentNode).get(0));
								$(node).remove();
								e.preventDefault();
								self.onheight(true);
								return false;
							}
						}
						if (self.dom_helper.is_last(node) && self.dom_helper.is_block(node.parentNode)) $('<br>').insertAfter(node);
						self.cursor_after($('<br>').insertAfter(node).get(0));
						e.preventDefault();
						self.onheight(true);
						return false;
					} else if (is_first && is_li && !e.shiftKey) {
						$(range.endContainer).parents().addBack().filter('li').before('<li><br></li>');
						e.preventDefault();
						self.onheight(true);
						return false;
					}
					if (is_li && !e.shiftKey) return true;
					range.insertNode(br = document.createElement("br"));
					if (is_li && e.shiftKey) range.insertNode(document.createElement("br"));
					range.endContainer.normalize();
					self.cursor_after(br);
					e.preventDefault();
					self.onheight(true);
					return false;
				}
			}

			if (keyCode === App.keycode.Tab) {
				e.preventDefault();
				e.stopPropagation();
				p = self.range().endContainer;
				while (p.nodeType === Node.TEXT_NODE) p = p.parentNode;
				if ($(p).is('pre')) self.insert_text("\t"); else self.insert_text("\u2003\u2003");
			}

			if (e.shiftKey && e.altKey && (e.ctrlKey || e.metaKey) && key.toLowerCase() === 'c') {
				e.preventDefault();
				e.stopPropagation();
				self.button('code');
			} else if (e.shiftKey && (e.ctrlKey || e.metaKey)) {
				switch (key.toLowerCase()) {
					case 'x':
						self.button('strikethrough');
						e.preventDefault();
						break;
					case '0':
						e.preventDefault();
						e.stopPropagation();
						if (self.obj.find('.editor__toolbar .list_todo').length) {
							self.button('list_todo');
						}
						break;
					case '7':
						e.preventDefault();
						e.stopPropagation();
						self.button('list_num');
						break;
					case '8':
						e.preventDefault();
						e.stopPropagation();
						self.button('list_bullet');
						break;
					case '9':
						e.preventDefault();
						e.stopPropagation();
						self.button('quote');
						break;
					case 'c':
						e.preventDefault();
						e.stopPropagation();
						self.button('inline_code');
						break;
					// case 'b': //
					// 	e.preventDefault();
					// 	e.stopPropagation();
					// 	self.button('section_break');
					// 	break;
				}

				if (e.metaKey && key.toLowerCase() === 'z') {
					if (self._snaptimeout) clearTimeout(self._snaptimeout);
					if (e.shiftKey) self.redo(); else self.undo();
					e.preventDefault();
				}
			} else if (e.ctrlKey || e.metaKey) {
				switch (key.toLowerCase()) {
					case 'b':
						self.button('bold');
						e.preventDefault();
						e.stopPropagation();
						break;
					case 'i':
						self.button('italic');
						e.preventDefault();
						e.stopPropagation();
						break;
					case 's':
						App.draft.save(true);
						e.preventDefault();
						e.stopPropagation();
						break;
					case 'h':
						self.set_color($('body').attr('data-color') ? self.colors_dark[0] : self.colors_light[0]);
						e.preventDefault();
						e.stopPropagation();
						break;
					case 'k':
						self.button('link', 'context');
						e.preventDefault();
						e.stopPropagation();
						break;
					case 'u':
						self.file_attach('ctrl-U');
						e.preventDefault();
						e.stopPropagation();
						break;
				}
				// if ($.browser.webkit) switch (key.toLowerCase()) {
				//   case 'b':
				//   case 'i':
				//   //case 's':
				//   case 'u':
				//     setTimeout(function() {
				//       self.body.find('span').each(function() {
				//         if ($(this).css('font-style') == 'italic') $(this).wrapInner('<i></i>').css('font-style', '');
				//         if ($(this).css('font-weight') == 'bold' || $(this).css('font-weight') == 700) $(this).wrapInner('<b></b>').css('font-weight', '');
				//         if ($(this).css('text-decoration') == 'line-through') $(this).wrapInner('<strike></strike>').css('text-decoration', '');
				//         if (!$(this).attr('style') && !$(this).attr('class')) $(this).contents().insertBefore(this).next().remove();
				//       });
				//       self.selection().collapseToEnd();
				//     }, 50);
				//   break;
				// }

				if (e.ctrlKey) {
					switch (key.toLowerCase()) {
						case 'z':
							if (self._snaptimeout) clearTimeout(self._snaptimeout);
							self.undo(); //document.execCommand('undo');
							e.preventDefault();
							break;
						case 'y':
							if (self._snaptimeout) clearTimeout(self._snaptimeout);
							self.redo(); //document.execCommand('redo');
							e.preventDefault();
							break;
					}
				}

				if (e.metaKey) {
					switch (key.toLowerCase()) {
						case 'z':
							if (self._snaptimeout) clearTimeout(self._snaptimeout);
							if (e.shiftKey) self.redo(); else self.undo();
							e.preventDefault();
							break;
					}
				}
			}

			if (keyCode === App.keycode.Space) {
				if (!self.num_spaces_sequential) self.num_spaces_sequential = 1; else self.num_spaces_sequential++;
				if (self._space_num_tm) clearTimeout(self._space_num_tm);
				self._space_num_tm = setTimeout(function () {
					self.num_spaces_sequential = 0;
				}, 300);
				range = self.range();
				if ((!self.num_spaces_sequential || self.num_spaces_sequential < 2) && !e.shiftKey && range.collapsed && range.endContainer.nodeType === Node.TEXT_NODE && range.endOffset == range.endContainer.textContent.length && /\s$/.test(range.endContainer.textContent) && self.dom_helper.is_inline(range.endContainer.parentNode)) {
					if (self.dom_helper.is_last(range.endContainer) || self.dom_helper.is_last_inFF(range.endContainer)) {
						node = range.endContainer;
						if (self.dom_helper.is_last_inFF(node)) $(node.nextSibling).remove();
						node.textContent = node.textContent.substring(0, node.textContent.length - 1);
						while (self.dom_helper.is_last(node) && self.dom_helper.is_inline(node.parentNode)) node = node.parentNode;
						txt = document.createTextNode("\u00a0");
						$(txt).insertAfter(node);
						self.cursor_after(txt);
						txt.parentNode.normalize();
						e.preventDefault();
						return false;
					}
				}
			}
			// if (keyCode === App.keycode.Backspace) {
			// 	range = self.range();
			// 	if (range.collapsed) {
			// 		let p;
			// 		if (range.commonAncestorContainer.nodeType === Node.TEXT_NODE) {
			// 			if (range.startOffset <= 1) p = range.commonAncestorContainer.previousSibling;
			// 		} else {
			// 			p = range.startContainer.childNodes[range.startOffset - 2];
			// 		}
			// 		if (p?.tagName && (p.tagName === 'WS-EMOJI' || p.tagName === 'HR')) p.remove();
			// 	}
			// }
			// if (keyCode === App.keycode.Delete) {
			// 	range = self.range();
			// 	if (range.collapsed) {
			// 		let p;
			// 		if (range.commonAncestorContainer.nodeType === Node.TEXT_NODE) {
			// 			if (range.commonAncestorContainer.length - range.endOffset <= 1) p = range.commonAncestorContainer.nextSibling;
			// 		} else {
			// 			p = range.startContainer.childNodes[range.startOffset];
			// 		}
			// 		if (p?.tagName && (p.tagName === 'WS-EMOJI' || p.tagName === 'HR')) p.remove();
			// 	}
			// }
			if (keyCode === App.keycode.Backspace || keyCode === App.keycode.Delete) {
				self.mention.sync();
			}
		},

		_before_text_len: null,
		beforeinput_delete: function (e) {
			const type = e.originalEvent.inputType;

			if (!type || !type.startsWith('delete')) return;

			const isBackspace =
				type === 'deleteContentBackward' ||
				type === 'deleteWordBackward';

			const isDelete =
				type === 'deleteContentForward' ||
				type === 'deleteWordForward';

			if (!isBackspace && !isDelete) return;

			self._before_text_len = self.get_plain_text().length;

			const range = self.range();
			if (!range.collapsed) {

				// fix android
				if (isBackspace) {
					const node = range.startContainer;
					if (node.nodeType === Node.TEXT_NODE && node.nodeValue === '\u00A0') {
						const prev = node.previousSibling;
						if (prev && prev.nodeType === Node.ELEMENT_NODE && (prev.classList.contains('invite') || prev.tagName === 'WS-EMOJI')) {
							prev.remove();
							node.remove();
							return true;
						}
					}
				}

				return false;
			}

			let is_processed = false;
			let p = null;
			let p2 = null;

			if (isBackspace) {
				if (range.commonAncestorContainer.nodeType === Node.TEXT_NODE) {
					if (range.startOffset <= 1) p = range.commonAncestorContainer.previousSibling;
				} else {
					p = range.startContainer.childNodes[range.startOffset - 2];
					p2 = range.startContainer.childNodes[range.startOffset];
				}
			}
			if (isDelete) {
				if (range.commonAncestorContainer.nodeType === Node.TEXT_NODE) {
					if (range.commonAncestorContainer.length - range.endOffset <= 1) p = range.commonAncestorContainer.nextSibling;
				} else {
					p = range.startContainer.childNodes[range.startOffset];
				}
			}

			if (
				(p && (p.tagName === 'WS-EMOJI' || p.tagName === 'HR'))
				|| (p && p.tagName === 'SPAN' && p.classList.contains('invite'))
				|| (p2 && p2.tagName === 'SPAN' && p2.classList.contains('invite'))
			) {

				// App.helper.nextTick(() => p.remove());
				if (p) p.remove();
				if (p2) p2.remove();
				// App.helper.next
				is_processed = true;
			}

			return is_processed;
		},

		oninput_delete: function () {

			if (
				self._before_text_len === null
				|| !self.input_tracked
				|| (self.input_tracked === 1 && self.symbol_tracked === '@')
				|| App.device.is_mobile()
			) {
				self._before_text_len = null;
				return;
			}

			const stopTracking = () => {
				self.stop_tracking();
				if (App.menu.in_editor) App.menu.hide();
			};

			const afterLen = self.get_plain_text().length;
			const diff = self._before_text_len - afterLen;

			self._before_text_len = null;

			if (diff <= 0) return;

			// універсальне зменшення
			if (!self.input_sequential_text || self.input_sequential_text.length < diff) {
				stopTracking();
				return;
			}

			self.input_sequential_text =
				self.input_sequential_text.slice(0, -diff);

			// поведінка по режимах
			switch (self.input_tracked) {

				case 1: // mention
					App.context_search.menu.apply(self.input_sequential_text, App.menu.obj_window);
					if (App.context_search.letters_with_empty_result === 3) {
						stopTracking();
					}
					break;

				case 2: // task
					App.menu.obj_window?.find('.switch_search_mode b').text(self.input_sequential_text);
					if (App.controls.task_select_and_go.is_server_mode) {
						App.controls.task_select_and_go.handle_server_search(self.input_sequential_text);
					} else {
						App.context_search.menu.apply(self.input_sequential_text, App.menu.obj_window, {callback: App.controls.task_select_and_go.draw_tree.bind(App.menu.obj_window)});
					}
					break;

				case 3: // emoji
					App.controls.emoji.inline_menu.handleSearch(self.input_sequential_text);
					break;

				case 4: // contacts
					if (self.input_sequential_text) {
						App.core.call_queue.add('editor_contact_search', App.controls.contact_select_and_go.helper_server_search, App.menu.obj_window, {
							search: self.input_sequential_text,
							request: {
								editor: 1,
								opt_mention: self.body.attr('data-mention') === 'on' ? 1 : 0,
								opt_task: self.body.attr('data-task') === 'on' ? 1 : 0,
							}
						}, 0.3);
					}
					break;
			}
		},


		onselectionchange: App.helper.debounce(function (e) {
			if (!self.is_active()) return; // TODO вішати обробник при focus і вбивати при blur
			if (!self.body.attr('data-mention')) return

			const sel = document.getSelection();
			if (!sel || !sel.isCollapsed) return;

			const editor_body = self.body.get(0);
			const node = sel.anchorNode;
			if (!editor_body.contains(node)) return;

			// намагаємось тримати курсор в полі виду
			// допомагає при фокусі і при Enter
			self.body.scrollToCaret();

			const range = sel.getRangeAt(0).cloneRange();
			range.setStart(editor_body, 0);

			const getTextBeforeCursor = function (root, range) {
				const walker = document.createTreeWalker(
					root,
					NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT
				);

				let text = '';

				while (walker.nextNode()) {
					const node = walker.currentNode;

					if (node === range.endContainer) {
						text += node.textContent.slice(0, range.endOffset);
						break;
					}

					if (node.nodeType === Node.TEXT_NODE) {
						text += node.textContent;
					}

					if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'BR') {
						text += ' ';
					}
				}

				return text;
			};

			const textBeforeCursor = getTextBeforeCursor(editor_body, range);

			const match = textBeforeCursor.match(
				/(^|[^\p{L}\p{N}])@([\p{L}\p{N}]*)$/u
			);

			if (match) {
				if (self.input_tracked) {
					if (self.input_tracked == 1 && self.symbol_tracked === '@') {
						const search_query = match[2];
						if (self.input_sequential_text !== search_query) {
							self.input_sequential_text = search_query;
							App.context_search.menu.apply(self.input_sequential_text, App.menu.obj_window);
							App.menu.obj_window?.find('.selected').scrollIntoViewIfNeeded();
						}
					}
				} else {
					// таймаут, щоб відкриття меню не заважало виділенню подвійним кліком
					setTimeout(() => {
						const getMentionCoords = function (range) {
							const r = range.cloneRange();
							r.collapse(true);
							const rects = r.getClientRects();
							if (rects.length) return { x: rects[0].x, y: rects[0].y };
							return {x: 0, y: 0};
						};
						const search_query = match[2];
						self.symbol_tracked = '@';
						self.input_tracked = 1;
						self.input_sequential_text = search_query;

						const findMentionStart = function (root, cursorRange) {
							let node = cursorRange.endContainer;
							let offset = cursorRange.endOffset;

							while (node && node !== root) {
								if (node.nodeType === Node.TEXT_NODE) {
									const text = node.textContent;
									const idx = text.lastIndexOf('@', offset - 1);
									if (idx !== -1) {
										return { node, offset: idx };
									}
									offset = text.length;
								}
								node = node.previousSibling;
							}
							return null;
						};
						const cursorRange = sel.getRangeAt(0).cloneRange();
						const start = findMentionStart(editor_body, cursorRange);

						if (!start) return;

						const mentionRange = cursorRange.cloneRange();
						mentionRange.setStart(start.node, start.offset);

						// const mentionRange = range.cloneRange();
						// mentionRange.setStart(
						// 	range.endContainer,
						// 	range.endOffset - (search_query.length + 1)
						// );
						self.rem_range = mentionRange;
						// self.save_range(true);
						// const text_position = self.getSelectionCoords();
						const text_position = getMentionCoords(mentionRange);
						self.helper_mention({ text_position, from_text: true, force_dropdown: true });
						App.menu.in_editor = true;
					}, 50);
				}
			} else if (self.symbol_tracked === '@' && self.input_tracked) {
				self.stop_tracking();
				if (App.menu.is_shown()) App.menu.hide();
			}
		}),

		get_plain_text: function () {
			const el = self.body.get(0);
			if (!el) return '';

			return el.textContent || '';
		},

		file_attach: function (letter) {
			// немає чіткого зв'язку редактора з кнопкою
			// не критично, бо зараз всі кнопки мають однаковий onclick
			// тому берему першу, яку знайдемо
			$('.menu--file-attach').find('[data-hotkey="' + letter + '"]').first().click();
		},

		helper_highlight: function (params) {
			params ||= {};
			let anchor = self.obj.find('.editor__toolbar [data-btn=color_bg]:visible').get(0);

			App.menu.show({
				anchor: anchor,
				type: params.type || '',
				offset: params.offset,
				box: '#editorHighlightMenu',
				width: 280,
				onshow: function () {
					let menu = $(this), bar = menu.find('.colors').empty(),
						text = menu.find('input[name=text]'),
						add_text = params.value?.add_text ?? false;

					text.val('');

					menu.find('[name*=clear]').toggleClass('hiddenBlock', add_text).off().on('click', function () {
						App.menu.hide();
						self.set_color('white');
					});

					menu.find('.menu__group > div:first-child').toggleClass('hiddenBlock', !add_text);

					self.colors_light.forEach(function (val, i) {
						let col = $('body').attr('data-color') ? self.colors_dark[i] : self.colors_light[i],
							it = $('<div/>'),
							bg = $('<i/>').css('backgroundColor', col).appendTo(it);

						it.attr('rel', col).on('click', function () {
							App.menu.hide();

							if (add_text && text.val().trim() !== '') self.insert_text(text.val().trim(), true);

							self.set_color($(this).attr('rel'));
						}).appendTo(bar);

						it.toggleClass('act', params.value?.color === col || params.value?.color === bg.css('backgroundColor'));
					});

					setTimeout(() => {
						if (add_text) text.focus()
					}, 50);
				}
			});
		},

		helper_link: function (params) {
			params ||= {};
			let anchor = self.obj.find('.editor__toolbar [data-btn=link]:visible').get(0);
			let text_position = anchor == null ? self.getSelectionCoords() : null;

			App.menu.show({
				anchor: anchor,
				type: params.type || '',
				box: '#editorLinkMenu',
				text_position: text_position,
				width: 330,
				onshow: function () {
					let menu = $(this),
						label = menu.find('input[name=label]'),
						href = menu.find('input[name=href]');

					label.val(params.value?.label || '');
					href.val(params.value?.href || '');

					let del_value = function () {
						App.menu.hide();
						self.restore_range();
						self.set_link('');
					}
					let set_value = function () {
						App.menu.hide();
						self.restore_range();
						if (href.val().trim() !== '' && label.val().trim() !== '') {
							self.set_link(href.val().trim(), label.val().trim());
						} else {
							self.set_link('');
						}
					}

					menu.find('[name*=cancel]').addClass('hiddenBlock');
					menu.find('[name*=delete]').toggleClass('hiddenBlock', params.value?.is_new ?? true);
					menu.find('[name*=open]').toggleClass('hiddenBlock', !App.helper.is_link(href.val())).off().on('click', function () {
						let url = href.val().trim();
						if (!url.includes('://')) url = 'https://' + url;
						App.core.new_window(url);
					});

					href.off().on('keydown', function (e) {
						let key = e.keyCode ? e.keyCode : e.charCode;
						if (key === App.keycode.Enter) {
							set_value();
							return false;
						}
					}).on('keyup', function () {
						menu.find('[name*=open]').toggleClass('hiddenBlock', !App.helper.is_link(href.val()));
						menu.find('[name*=cancel]').removeClass('hiddenBlock');
					});
					label.off().on('keydown', function (e) {
						let key = e.keyCode ? e.keyCode : e.charCode;
						if (key === App.keycode.Enter) {
							set_value();
							return false;
						}
					}).on('keyup', function () {
						menu.find('[name*=cancel]').removeClass('hiddenBlock');
					});
					menu.find('[name*=cancel]').off().on('click', () => {
						App.menu.hide();
						self.restore_range();
					});
					menu.find('[name*=delete]').off().on('click', del_value);
					menu.find('[name*=primary]').off().on('click', set_value);

					App.helper.nextTick(() => {
						if (label.val().trim() !== '' && href.val().trim() !== '') {
							if (App.device.is_mobile()) {
								label.focus().select();
							} else {
								menu.find('button.btn-primary').focus()
							}
						} else if (label.val().trim() === '' || href.val().trim() !== '') label.focus_select_desktop();
						else href.focus_select_desktop();
					}, 100);
				}
			})
		},

		helper_mention: function (params) {
			let anchor = self.obj.find('.editor__toolbar .mention:visible').get(0);
			let endpoint = '', hidden = [];
			let request = {
				type: 'mention', ...(params?.from_text === true ? {editor: '1'} : {}),
				opt_task: self.body.attr('data-task') === 'on' ? 1 : 0,
			};
			if (App.task_create.is_shown()) {
				if (App.task_create.components.project.get_ids().length !== 1) return false;
				hidden = App.task_create.obj_window.find('input[name=hidden]').val().toIntArray();
				endpoint = App.task_create.helper_user_endpoint();
			} else if (App.task_view.is_shown()) {
				hidden = App.comment_form.obj.find('input[name=hidden]').val().toIntArray();
				endpoint = App.helper.url.add_query(App.task_view.url, App.actions.get('task_user_select_and_go:show'))
			} else return;
			if (hidden.length) request.hidden = hidden.join(',');

			if (self.input_tracked > 0) self.input_tracked = 1;
			App.controls.user_select_and_go.show_context(anchor, endpoint, {
				request,
				replace: params.replace || false,
				type: params.type || '',
				backup: params.backup || false,
				text_position: params.text_position || null,
				no_anim: params.no_anim || false,
				force_dropdown: params.force_dropdown ?? false,
				width: 360,
				use_prev_height: params.replace && !params.text_position,
				onload: function () {
					let menu = $(this);
					menu.on('click', '.menu__item[data-id]', function () {
						self.mention.apply(this, $(this).attr('data-id'));
						App.menu.hide();
					})
					menu.on('click', '.search_contact', function () {
						const search_query = menu.find('.menu__group-search input').val();
						self.helper_contact_select({...params, search_query, replace: true});
						if (params.from_text) self.restore_range();
						return false
					});
					menu.on('click', '.search_task', function () {
						const search_query = menu.find('.menu__group-search input').val();
						self.helper_task_select({...params, search_query, replace: true});
						if (params.from_text) self.restore_range();
						return false
					});
					if (!App.device.is_mobile() && !params?.from_text) menu.find('.menu__group__wrapper').css('min-height', 240);
				},
				onshow: function () {
					let menu = $(this);
					if (params.search_query || params.search_query === '') {
						menu.find('.menu__group-search input').val(params.search_query).trigger('keyup');
					} else {
						App.context_search.menu.apply(self.input_sequential_text, menu);
					}
				}
			});
		},

		emoji_menu_container: function () {
			let menuId = 'editorEmojiMenu';

			if ($('#' + menuId).length === 0) {
				$('#fixed_container').append($('<div>', {id: menuId, class: 'menu menu-secondary'}))
			}

			return $('#' + menuId);
		},

		helper_emoji_select: function (params) {

			if (params.text_position) {
				self.helper_inline_emoji_select(params);
				return;
			}

			let anchor = self.obj.find('.editor-btn.emoji:visible').get(0);
			if (anchor == null) return;

			self.emoji_menu_container().empty().append(
				$('<div>').addClass('menu__group-emoji').css('height', '370px')
			);

			App.menu.show({
				anchor: anchor,
				type: params.type || '',
				replace: params.replace || false,
				backup: params.backup || false,
				text_position: params.text_position || null,
				box: self.emoji_menu_container(),
				width: 312,
				force_dropdown: true
			});

			self.emoji_menu_container().find('.menu__group-emoji').append(
				App.controls.emoji.getPicker(function (e) {
					self.insert($('<ws-emoji id="' + e.id + ':' + e.unified + '" native="' + e.native + '"></ws-emoji>').get(0), true);
					self.stop_tracking();
					App.menu.hide();
				}, null, params.text_position == null)
			);
		},

		helper_inline_emoji_select: function (params) {
			let anchor = self.obj.find('.editor-btn.emoji:visible').get(0);
			if (anchor == null) return;

			App.controls.emoji.inline_menu.search_show('', {
				text_position: params.text_position || null,
				inline_emoji_select: params.from_text ? true : false,
				in_editor: params.from_text ? true : false,
				focus: true,
				onEmojiSelect: function (e) {
					self.insert($('<ws-emoji id="' + e.id + ':' + e.unified + '" native="' + e.native + '"></ws-emoji>').get(0), true);
					self.stop_tracking();
					App.menu.hide();
				},
			});
		},

		helper_contact_select: function (params) {
			let anchor = self.obj.find('.editor__toolbar .mention:visible').get(0);
			params ||= {};

			if (self.input_tracked > 0) self.input_tracked = 4;
			App.controls.contact_select_and_go.show_context(anchor, null, {
				request: {
					init: 1, type: 'mention', ...(params?.from_text === true ? {editor: '1'} : {}),
					opt_mention: self.body.attr('data-mention') === 'on' ? 1 : 0,
					opt_task: self.body.attr('data-task') === 'on' ? 1 : 0,
				},
				type: params.type || '',
				replace: params.replace || false,
				backup: params.backup || false,
				text_position: params.text_position || null,
				no_anim: params.no_anim || false,
				width: 360,
				use_prev_height: params.replace && !params.text_position,
				onload: function () {
					let menu = $(this);
					menu.on('click', '.menu__item[data-id]', function () {
						self.contact.apply(this, $(this).attr('data-id'));
					});
					menu.on('click', '.search_mention', function () {
						const search_query = menu.find('.menu__group-search input').val();
						self.helper_mention({...params, search_query, replace: true});
						if (params.from_text) self.restore_range();
						return false
					});
					menu.on('click', '.search_task', function () {
						const search_query = menu.find('.menu__group-search input').val();
						self.helper_task_select({...params, search_query, replace: true});
						if (params.from_text) self.restore_range();
						return false
					});
					if (!App.device.is_mobile() && !params?.from_text) menu.find('.menu__group__wrapper').css('min-height', 240);
				},
				onshow: function () {
					let menu = $(this);
					if (params.search_query || params.search_query === '') {
						menu.find('.menu__group-search input').val(params.search_query).trigger('keyup');
					} else if (self.input_sequential_text) {
						App.core.call_queue.add('editor_contact_search', App.controls.contact_select_and_go.helper_server_search, menu, {
							search: self.input_sequential_text,
							request: {
								editor: 1,
								opt_mention: self.body.attr('data-mention') === 'on' ? 1 : 0,
								opt_task: self.body.attr('data-task') === 'on' ? 1 : 0,
							}
						}, 0);
					}
				}
			});
		},

		helper_task_select: function (params) {
			let anchor = self.obj.find('.editor__toolbar .task:visible').get(0) || self.obj.find('.editor__toolbar .mention:visible').get(0);
			params ||= {};
			let endpoint = '';
			if (App.task_create.is_shown()) {
				if (App.task_create.components.project.get_ids().length !== 1) return false;
				endpoint = App.task_create.obj_window.attr('ajax-action');
			} else if (App.chat_view.is_shown()) {
				endpoint = App.helper.endpoint.ajax(App.task_view.get_id_project() || App.sidebar.featured_project.current.id);
			} else if (App.task_view.is_shown()) {
				endpoint = App.helper.endpoint.ajax(App.task_view.get_id_project());
			} else return;

			if (self.input_tracked > 0) self.input_tracked = 2;
			App.controls.task_select_and_go.show_context(anchor, endpoint, {
				request: {
					type: 'mention', ...(params?.from_text === true ? {editor: '1'} : {}),
					opt_mention: self.body.attr('data-mention') === 'on' ? 1 : 0,
					opt_task: self.body.attr('data-task') === 'on' ? 1 : 0,
				},
				type: params.type || '',
				replace: params.replace || false,
				backup: params.backup || false,
				text_position: params.text_position || null,
				no_anim: params.no_anim || false,
				width: 360,
				use_prev_height: params.replace && !params.text_position,
				onload: function () {
					let menu = $(this);
					menu.on('click', '.menu__item[data-id]', function () {
						self.task.apply(this);
						App.menu.hide();
					});
					menu.on('click', '.search_mention', function () {
						const search_query = menu.find('.menu__group-search input').val();
						self.helper_mention({...params, search_query, replace: true});
						if (params.from_text) self.restore_range();
						return false
					});
					menu.on('click', '.search_contact', function () {
						const search_query = menu.find('.menu__group-search input').val();
						self.helper_contact_select({...params, search_query, replace: true});
						if (params.from_text) self.restore_range();
						return false
					});
					if (!App.device.is_mobile() && !params?.from_text) menu.find('.menu__group__wrapper').css('min-height', 240);
				},
				onshow: function () {
					let menu = $(this);
					if (params.search_query || params.search_query === '') {
						menu.find('.menu__group-search input').val(params.search_query).trigger('keyup');
					} else {
						App.context_search.menu.apply(self.input_sequential_text, menu, {callback: App.controls.task_select_and_go.draw_tree.bind(menu)});
					}
				},
				on_project_change: function () {
					self.restore_range();
				},
				on_server_search: function () {
					if (self.input_tracked) {
						self.restore_range();
					}
				}
			});
		},

		apply_ai_results: function(html) {
			if (html) {
				if (self.ai_selection) {
					self.restore_range();
					self.replaceSelectionHTML(html);
					self.normalizeBlocks();
				} else {
					self.body.html(html);
				}
				self.update();
				// self.init_from_html(response.html);
			}
			// if (response.name) {
			// 	self;
			// }
			self.update();
		},

		onclick: function (e) {
			let el = e.target ? e.target : ((e.srcElement) ? e.srcElement : null);
			let def_el = el
			if (!el) return;
			if ($(el).is('a') || (el.parentNode && (el = el.parentNode) && $(el).is('a')) || (el.parentNode && (el = el.parentNode) && $(el).is('a'))) {
				if (self.selection().toString()) return true;
				if ($(el).hasClass('inline_task')) {
					if ($(el).outerWidth() - e.pageX + $(el).offset().left <= 25) {
						$(el).remove();
						self.update();
					}
					e.preventDefault();
					e.stopPropagation();
					return false;
				}
				self.cursor_wrap(el);
				self.update();
				e.stopPropagation();
				return false;
			}
			el = def_el;
			if ($(el).is('.contact') || (el.parentNode && (el = el.parentNode) && $(el).is('.contact')) || (el.parentNode && (el = el.parentNode) && $(el).is('.contact'))) {
				if (self.selection().toString()) return true;
				if ($(el).outerWidth() - e.pageX + $(el).offset().left > 25) {
					self.cursor_wrap(el);
				} else {
					self.contact.add_formdata($(el).attr('rel'), false);
					$(el).remove();
				}
				e.stopPropagation();
				return false;
			}
			el = def_el;
			if ($(el).is('.invite') || (el.parentNode && (el = el.parentNode) && $(el).is('.invite')) || (el.parentNode && (el = el.parentNode) && $(el).is('.invite'))) {
				if (self.selection().toString()) return true;
				if ($(el).outerWidth() - e.pageX + $(el).offset().left > 25) {
					self.cursor_wrap(el);
				} else {
					if ($(el).hasClass('invite_old')) {
						$(el).remove();
					} else {
						$(el).remove();
						self.mention.sync();
					}
				}
				e.stopPropagation();
				return false;
			}
			self.stop_tracking();
			if (App.menu.in_editor) App.menu.hide();
		},

		onresize: function () {
		},
		onheight: function (force_vis) {
		},

		// onresize: function () {
		// 	if (self.body == null) return;
		// 	self.body.css({ minHeight: 0, maxHeight: 0, height: 0 });
		//
		// 	let toolbar = self.body.parent().find('.editor__toolbar-fixed');
		// 	let with_toolbar = self.body.closest('.with-topToolbar').length > 0;
		//
		// 	let main_h = self.body.parent().height();
		// 	let max_growth = parseInt(self.body.attr('data-max-growth') || '84');
		//
		// 	if (toolbar.length === 1 && with_toolbar) {
		// 		main_h-= toolbar.outerHeight();
		// 	}
		//
		// 	if (self.body.attr('data-growth-enabled') === 'no') {
		// 		max_growth = 0;
		// 	}
		//
		// 	self.body.css({
		// 		minHeight: main_h,
		// 		// maxHeight: main_h + Math.max(0, max_growth),
		// 		maxHeight: 'unset',
		// 		height: 'auto',
		// 		boxSizing: 'border-box'
		// 	});
		// },

		// onheight: function (force_vis) {
		// 	if (App.device.is_mobile()) return false;
		// 	if (!self.lastheight) {
		// 		self.lastheight = self.body.height();
		// 	} else if (self.lastheight != self.body.height() || force_vis) {
		// 		self.lastheight = self.body.height();
		// 		h1 = self.obj.offset().top, h2 = $(window).height(), p1 = 292, p2 = 170;
		// 		// if ($('body').hasClass('bd_nomenu')) {
		// 		// 	p1 = 260, p2 = 220;
		// 		// }
		// 		if (!self.body.attr('data-stick')) {
		// 		} else if (h1 + self.lastheight > $(window).scrollTop() + h2 - p2) $(window).scrollTop(h1 + self.lastheight - h2 + p2);
		// 		else if (h1 < $(window).scrollTop() + p1 - p2) $(window).scrollTop(h1 - p1 + p2);
		// 		if (force_vis) {
		// 			let coord = self.getSelectionCoords();
		// 			cur_pos = coord.y + $(window).scrollTop() - self.body.offset().top - 5;
		// 			if (cur_pos > self.lastheight - 40) self.body.scrollTop(self.body.scrollTop() + cur_pos - self.lastheight + 40);
		// 			else if (cur_pos < 20) self.body.scrollTop(self.body.scrollTop() + cur_pos - 20);
		// 		}
		// 	}
		// },

		button_state: function (type) {
			if (!self.is_active()) return false;

			try {
				state = document.queryCommandState(type);
			} catch (e) {
				state = false;
			}
			return state;
		},

		button_value: function (type) {
			try {
				state = "" + document.queryCommandValue(type);
			} catch (e) {
				state = '';
			}
			return state;
		},

		//-----------------------------------------------------------------------
		//
		//   Some scecific helper functions
		//
		//-----------------------------------------------------------------------

		task: {
			create_dummy: function (id) {
				let node = this.create_node({id, priority_text: '#', name: id})
				node.classList.add('inline_task-dummy')
				return node;
			},
			create_node: function (params) {
				params ||= {};
				return $('<a></a>')
					.addClass('inline_task')
					.attr('spellcheck', false)
					.attr('contenteditable', false)
					.attr('href', params.url || '')
					.attr('rel', params.id)
					.html(
						(params.stage || '')
						+ '<span>' + App.helper.html.encode(params.name || '') + '</span>'
						+ '<ws-icon name="cancel_sm:cancel_sm-solid"></ws-icon>'
					)
					.get(0);
			},
			parse_menu_item: function (el) {
				el = $(el);

				return {
					id: el.attr('data-id'),
					url: el.attr('data-url'),
					name: App.helper.html.encode(el.find('.in').text()),
					priority: (el.find('.priorb').attr('class') || '').replace(/\D/g, ''),
					priority_text: el.find('.priorb').text() || '',
					stage: el.find('task-stage').prop('outerHTML'),
				};
			},
			find_by_id: function (id, callback) {
				$.get({
					url: App.helper.url.add_query(App.helper.endpoint.primary(), App.actions.get('task_search:show') + '&search=' + encodeURIComponent('#' + id)),
					success: function (html) {
						let menu = $('<div></div>');
						let task = menu.html(html).find('.menu__item[data-id=' + id + ']');

						if (task.length === 1) {
							callback(self.task.parse_menu_item(task));
						} else {
							callback(null)
						}
					},
					error: () => callback(null)
				})
			},
			apply: function (el) {
				self.insert(self.task.create_node(self.task.parse_menu_item(el)), true)
			}
		},

		mention: {
			is_applicable: function () {
				return self.obj.find('[name=ids_contact]').length === 1;
			},
			sync: function () {
				if (self.body.attr('data-mention')) {
					let ids = [];
					self.body.find('.invite').not('.invite_old').each(function () {
						ids.push($(this).attr('rel'))
					});
					self.mention.restore_formdata(ids);
					ids = [];
					self.body.find('.contact').each(function () {
						ids.push($(this).attr('rel'))
					});
				}
			},
			apply: function (el, id) { // from wysiwyg editor
				let justText = !self.obj || !self.body.attr('data-mention');
				self.mention.insert(App.helper.html.encode($(el).find('.in').text()), id, justText);
				self.mention.add_formdata(id, true);
				App.menu.hide();
			},
			create_element: function (text, id, just_text) {
				text = text.trim();
				let ico_delete = '<ws-icon name="cancel_sm:cancel_sm-solid"></ws-icon>';
				if (!text) return;
				let span;
				let avatar = App.team[id].avatar || '';
				if (just_text) {
					span = document.createTextNode(text);
				} else {
					span = $('<span></span>').addClass('invite').attr('spellcheck', false).attr('contenteditable', false).attr('rel', id).html(avatar + App.helper.html.encode(text) + ico_delete).get(0);
				}

				return span;
			},
			insert: function (text, id, just_text) {
				self.insert(self.mention.create_element(text, id, just_text), true);

				if (App.menu.in_editor) {
					App.menu.hide();
					return false;
				}
			},

			clean: function () {
				self.body.find('.invite').each(function () {
					let id = parseInt($(this).attr('rel')), is_old = $(this).hasClass('invite_old');
					$(this).find('span, ws-icon').remove();
					let el = self.mention.create_element(App.team[id]?.name || $(this).text(), id);
					$(el).toggleClass('invite_old', is_old);
					$(this).replaceWith(el);
				});
			},

			save: function (html) {
				const el = $('<div>');

				el.html(html);
				el.find('.invite').each(function () {
					$(this).children('span, ws-icon').remove();
				});

				return el.html();
			},

			restore_formdata: function (ids) {
				if (!this.is_applicable()) return;

				self.obj.find('[name=ids_invite]').val(ids.join(',')).trigger('update');
			},

			add_formdata: function (id, is_on) {
				if (!this.is_applicable()) return;

				let ids = self.obj.find('[name=ids_invite]').val().split(',').filter(Number);
				let index = ids.indexOf(id);
				if (is_on && index === -1) {
					ids.push(id);
				}
				if (!is_on && index !== -1) {
					ids.splice(index, 1);
				}
				self.obj.find('[name=ids_invite]').val(ids.join(',')).trigger('update');
			},
		},

		contact: {
			is_applicable: function () {
				return self.obj.find('[name=ids_contact]').length === 1;
			},
			apply: function (el, id) {
				self.contact.insert(typeof (el) == 'string' ? el : $(el).find('.in').justtext(), id);
				self.contact.add_formdata(id, true);
				App.menu.hide_all();
			},
			create_element: function (text, id) {
				let ico_delete = '<ws-icon name="cancel_sm:cancel_sm-solid"></ws-icon>';
				let ico_contact = '<ws-icon name="contacts"></ws-icon>';
				return $('<span></span>')
					.addClass('contact')
					.attr('spellcheck', false)
					.attr('contenteditable', false)
					.attr('rel', id)
					.html(ico_contact + App.helper.html.encode(text) + ico_delete).get(0);
			},
			insert: function (text, id, just_text) {
				self.insert(self.contact.create_element(text, id), true);
			},
			clean: function () {
				self.body.find('.contact').each(function () {
					let id = parseInt($(this).attr('rel'));
					$(this).find('span, ws-icon').remove();
					$(this).replaceWith(self.contact.create_element($(this).text(), id));
				});
			},
			restore_formdata: function (ids) {
				if (!this.is_applicable()) return;

				self.obj.find('[name=ids_contact]').val(ids.join(','));
			},
			add_formdata: function (id, is_on) {
				if (!this.is_applicable()) return;

				let ids = self.obj.find('[name=ids_contact]').val().split(',');
				let index = ids.indexOf(id);
				if (is_on && index === -1) {
					ids.push(id);
				}
				if (!is_on && index !== -1) {
					ids.splice(index, 1);
				}

				self.obj.find('[name=ids_contact]').val(ids.join(','));
			},
		},

		is_inline_local1: new RegExp('^https?:\/\/' + document.location.hostname + '\/d\/([01-9]+)\/$', 'i'),
		is_inline_local2: new RegExp('^https?:\/\/' + document.location.hostname + '\/project\/([01-9]+)\/([01-9]+)\/', 'i'),
		is_inline_file: function (href) {
			return /^clip:/i.test(href) ||
				/^http:\/\/(joxi\.ru|c2n\.me)\/[01-9a-z]+$/i.test(href) ||
				(/\.(jpg|png|gif)$/i.test(href) && !/https:\/\/www\.dropbox\.com/i.test(href)) ||
				/^https?:\/\/(youtu\.be\/|www\.youtube\.com\/watch\?v=)([01-9a-z_]+)$/i.test(href) ||
				/^https?:\/\/vimeo.com[^"]+\/([01-9]+)$/i.test(href) ||
				self.is_inline_local1.test(href) ||
				this.is_inline_local2.test(href);
		},

		_makeColor: function (v) {
			return (typeof v != "number") ? v : "rgb(" + (v & 0xFF) + "," + ((v >> 8) & 0xFF) + "," + ((v >> 16) & 0xFF) + ")";
		},

		base64toBlob: function (base64Data, contentType) {
			contentType = contentType || '';
			let sliceSize = 1024;
			let byteCharacters = atob(base64Data);
			let bytesLength = byteCharacters.length;
			let slicesCount = Math.ceil(bytesLength / sliceSize);
			let byteArrays = new Array(slicesCount);

			for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
				let begin = sliceIndex * sliceSize;
				let end = Math.min(begin + sliceSize, bytesLength);

				let bytes = new Array(end - begin);
				for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
					bytes[i] = byteCharacters[offset].charCodeAt(0);
				}
				byteArrays[sliceIndex] = new Uint8Array(bytes);
			}
			return new Blob(byteArrays, {type: contentType});
		},

		getSelectionCoords: function () {
			let sel = document.selection, range, rects, rect;
			let x = 0, y = 0;
			if (window.getSelection) {
				sel = window.getSelection();
				if (sel.rangeCount) {
					range = sel.getRangeAt(0).cloneRange();
					if (range.getClientRects) {
						range.collapse(true);
						rects = range.getClientRects();
						if (rects.length > 0) {
							rect = rects[0];
						}
						if (typeof rect != 'undefined') {
							x = rect.left;
							y = rect.top;
						}
					}
					// Fall back to inserting a temporary element
					if (x == 0 && y == 0) try {
						let span = document.createElement("span");
						if (span.getClientRects) {
							// Ensure span has dimensions and position by
							// adding a zero-width space character
							span.appendChild(document.createTextNode("\u200b"));
							range.insertNode(span);
							rect = span.getClientRects()[0];
							x = rect.left;
							y = rect.top;
							let spanParent = span.parentNode;
							spanParent.removeChild(span);
							// Glue any broken text nodes back together
							spanParent.normalize();
						}
					} catch (e) {
					}
				}
			}
			return {x: x, y: y};
		},

		//-----------------------------------------------------------------------
		//
		//   AI Generated Helpers
		//
		//-----------------------------------------------------------------------

		expandSelectionToBlock: function () {
			const root = self.body.get(0);
			const sel = window.getSelection();
			if (!sel || !sel.rangeCount) return;

			const range = sel.getRangeAt(0);

			const blockTags = new Set([
				"P", "DIV", "LI", "BLOCKQUOTE",
				"H1", "H2", "H3", "H4", "H5", "H6",
				"UL", "OL", "PRE"
			]);

			function startBoundaryOK(range, root) {

				const c = range.startContainer;
				const o = range.startOffset;

				// межа документа
				if (c === root && o === 0) return true;

				// block boundary
				if (c.nodeType === 1) {
					const node = c.childNodes[o];
					if (node && isBlock(node)) return true;
				}

				// після <br>
				if (c.nodeType === 1 && o > 0) {
					const prev = c.childNodes[o - 1];
					if (prev && prev.nodeName === "BR") return true;
				}

				return false;
			}

			function endBoundaryOK(range, root) {

				const c = range.endContainer;
				const o = range.endOffset;

				if (c === root && o === root.childNodes.length) return true;

				if (c.nodeType === 1) {
					const node = c.childNodes[o - 1];
					if (node && isBlock(node)) return true;
				}

				if (c.nodeType === 1) {
					const next = c.childNodes[o];
					if (next && next.nodeName === "BR") return true;
				}

				return false;
			}

			function isBlock(node) {
				if (!node || node.nodeType !== 1) return false;

				return blockTags.has(node.tagName);
			}

			function findBlock(node) {
				while (node && node !== root) {
					if (node.nodeType === 1 && blockTags.has(node.tagName)) {
						return node;
					}
					node = node.parentNode;
				}
				return null;
			}

			function findPrevBR(node) {
				while (node && node !== root) {
					if (node.previousSibling) {
						node = node.previousSibling;

						if (node.nodeName === "BR") return node;

						while (node.lastChild) node = node.lastChild;
					} else {
						node = node.parentNode;
					}
				}
				return null;
			}

			function findNextBR(node) {
				while (node && node !== root) {
					if (node.nextSibling) {
						node = node.nextSibling;

						if (node.nodeName === "BR") return node;

						while (node.firstChild) node = node.firstChild;
					} else {
						node = node.parentNode;
					}
				}
				return null;
			}

			const startBlock = findBlock(range.startContainer);
			const endBlock = findBlock(range.endContainer);

			const newRange = document.createRange();

			// START
			if (startBoundaryOK(range, root)) {
				newRange.setStart(range.startContainer, range.startOffset);
			} else if (startBlock) {
				newRange.setStartBefore(startBlock);
			} else {
				const prevBR = findPrevBR(range.startContainer);

				if (prevBR) newRange.setStartAfter(prevBR);
				else newRange.setStart(root, 0);
			}

			// END
			if (endBoundaryOK(range, root)) {
				newRange.setEnd(range.endContainer, range.endOffset);
			} else if (endBlock) {
				newRange.setEndAfter(endBlock);
			} else {
				const nextBR = findNextBR(range.endContainer);

				if (nextBR) newRange.setEndBefore(nextBR);
				else newRange.setEnd(root, root.childNodes.length);
			}

			sel.removeAllRanges();
			sel.addRange(newRange);
		},

		getSelectionHTML: function () {
			const selection = window.getSelection();
			if (!selection || !selection.rangeCount) return "";

			const range = selection.getRangeAt(0);
			const fragment = range.cloneContents();

			const container = document.createElement("div");
			container.appendChild(fragment);

			return container.innerHTML;
		},

		replaceSelectionHTML: function (html) {
			const selection = window.getSelection();
			if (!selection || !selection.rangeCount) return;

			const range = selection.getRangeAt(0);
			const template = document.createElement("template");
			template.innerHTML = html;
			const fragment = template.content;
			range.deleteContents();
			range.insertNode(fragment);
			selection.removeAllRanges();
		},

		normalizeBlocks: function () {
			const root = self.body.get(0);
			const lists = root.querySelectorAll("ol, ul");

			lists.forEach(list => {
				const next = list.nextElementSibling;
				if (
					next &&
					next.tagName === list.tagName &&
					next.className === list.className
				) {
					while (next.firstChild) {
						list.appendChild(next.firstChild);
					}
					next.remove();
				}
			});
			root.querySelectorAll("p").forEach(p => {
				const text = p.textContent.replace(/\u00A0/g, "").trim();
				if (!text && p.children.length === 0) {
					p.remove();
				}
			});
			root.querySelectorAll("br + br").forEach(br => br.remove());
			root.normalize();
		},

		//-----------------------------------------------------------------------
		//
		//   Dom Helper
		//
		//-----------------------------------------------------------------------

		dom_helper: {
			is_inline: function (node) {
				return /^(span|s|strike|b|u|i|em|strong|font|scode)$/i.test(node.nodeName);
			},

			is_block: function (node) {
				return /^(div|p|address|pre|blockquote|li)$/i.test(node.nodeName);
			},

			is_block_or_br: function (node) {
				return /^(div|p|address|pre|blockquote|li|br)$/i.test(node.nodeName);
			},

			is_quote: function (node) {
				return /^(address|pre|blockquote)$/i.test(node.nodeName);
			},

			is_br: function (node) {
				return node && node.nodeName.toLowerCase() == 'br';
			},

			is_hr: function (node) {
				return node && node.nodeName.toLowerCase() == 'hr';
			},

			is_last: function (node) {
				return !node.nextSibling || (node.nextSibling.nodeType === Node.TEXT_NODE && !node.nextSibling.textContent);
			},

			is_first: function (node) {
				return !node.previousSibling || (node.previousSibling.nodeType === Node.TEXT_NODE && !node.previousSibling.textContent);
			},

			is_last_inFF: function (node) {
				return node.nextSibling && this.is_br(node.nextSibling) && !node.nextSibling.nextSibling;
			},

			replace_by_content: function (el) {
				let txt = $(el).html().trim();
				if (!txt) $(el).remove(); else {
					if (el.previousSibling && !this.is_block_or_br(el.previousSibling) && !/^<(div|p|ul|ol|address|pre|blockquote|li)/i.test(txt)) txt = '<br>' + txt;
					if (el.nextSibling && !this.is_block_or_br(el.nextSibling) && !/<(\/(div|p|ul|ol|address|pre|blockquote|li)|br[^>]*)>$/i.test(txt)) txt = txt + '<br>';
					$(el).replaceWith(txt);
				}
			},

			update_inline_br: function (node) {
				if (node.lastChild && this.is_br(node.lastChild)) {
					$(node).after(node.lastChild);
				}
				return true;
			},

			find_last_text_node: function (el) {
				if (el == null) return null;

				if (el.childNodes) for (let i = el.childNodes.length - 1; i >= 0; i--) {
					if (el.childNodes[i].nodeType === Node.TEXT_NODE) return el.childNodes[i];
					let subres = this.find_last_text_node(el.childNodes[i]);
					if (subres) return subres;
				}
				return null;
			},

		},

		debug: {
			enabled: false,
			stack: [],

			log(msg) {
				if (!this.enabled) return;
				this.stack.push({
					time: Date.now(),
					msg: JSON.stringify(msg),
				});
			},

			clear() {
				this.stack.length = 0;
			},

			to_html() {
				return '<div class="modal__content__block scrollZone editor-debug">'
					+ this.stack
						.map(row => `<div class="editor-debug__row">${row.msg}</div>`)
						.join('')
					+ '</div>';
			},

			show() {
				App.modal.show({
					title: 'Editor debug',
					html: this.to_html()
				});
			}
		},

		// це ламало редактор в задачі, якщо ходити по сторінках на фоні
		// onload: function () {
		// 	let obj = $('#editor');
		// 	if (obj.length) {
		// 		self.init(obj);
		// 	}
		// },

		onBoot: function () {
			App.bus.app.on('menu_unload', function () {
				if (App.menu.obj_window && App.menu.obj_window.is('#inlineEmojiMenu')) return;
				self.stop_tracking();
			});
			App.bus.other_tab.on('ui_state', function ({state}) {
				const { default: default_state } = state;
				const { editor_toolbar } = default_state || {};
				if (editor_toolbar !== undefined && self.body && App.device.is_lg_width()) {
					if (!App.comment_form.is_expanded()) self.toggle_toolbar(editor_toolbar)
				}
			});

			document.addEventListener('selectionchange', self.onselectionchange);
		},

		onLoadPage: function () {
			// self.onload();
		}
	};
})();
